import axios from 'axios';
import type {
  ComptoirClient, ComptoirClientInput, ComptoirClientOption, ComptoirClientSituation, ComptoirOffre, ComptoirOffreInput, ComptoirOptions, ComptoirStats, ComptoirUserOption, ComptoirDesignation, Paginated,
  ComptoirService, ComptoirServiceDetail, ComptoirServiceStats, ComptoirLivraison, ComptoirHistoryLine,
  ComptoirServiceProduction, ComptoirProductionTravaux, ComptoirCaisseJournal, ComptoirCaisseMeta, ComptoirCaisseMove, ComptoirCaisseOuverture, ComptoirCaisseImpact,
  ComptoirCaisseParams, ComptoirSuivi, ComptoirSuiviService, ComptoirSuiviMeta, ComptoirEtape, ComptoirEtapeInput,
  ComptoirSlotCheck, ComptoirSaisieInput, ComptoirEtapeAction, ComptoirPlanning, ComptoirDashboard, ComptoirFinance,
  ComptoirPaiement, ComptoirPaiementInput, ComptoirPaiementImpact, ComptoirPaiementUpdate, ComptoirSuppressionImpact,
  ComptoirDocuments, ComptoirMatiereEntreprise, ComptoirStockMatiere,
} from '../types/comptoir';
import { LoginRequest, LoginResponse, User, CreateUserRequest, UpdateUserRequest } from '../types/auth';
import { Category, Unit, Article, CategoryCreate, UnitCreate, ArticleCreate, ArticleUpdate } from '../types';
import { Supplier, CreateSupplierRequest, UpdateSupplierRequest, SupplierListResponse } from '../types/supplier';
import { StockEntryNew, StockEntryNewCreate, StockEntryNewUpdate, StockEntryNewListResponse } from '../types/stockEntryNew';
import {
  DessinOwnerType,
  PlanDestinataire,
  PlanFields,
  PlanFormMeta,
  PlansListResponse,
  ProjetDessin,
  ProjetDessinListResponse,
  ProjetDessinUpdate,
  ProjetDessinVersion,
  ProjetWithDessinCountListResponse,
} from '../types/projetDessin';
import { BEBoard, BECandidat, BECard, BEEtat, BEType } from '../types/bureauEtudes';
import { Client, ClientCreate, ClientUpdate, ClientListResponse } from '../types/client';
import { Service, ServiceCreate, ServiceUpdate, ServiceListResponse } from '../types/service';
import { Demandeur, DemandeurCreate, DemandeurUpdate, DemandeurListResponse } from '../types/demandeur';
import { Projet, ProjetCreate, ProjetUpdate, ProjetListResponse } from '../types/projet';
import { STC, STCCreate, STCUpdate, STCListResponse, STCPrefill } from '../types/stc';
import { InventoryRecord, InventoryRecordCreate, InventoryRecordUpdate, InventoryListResponse, InventorySummary, CalculatedInventory } from '../types/inventory';
import { AuditLog, AuditLogFilter, AuditLogPagination } from '../types/auditLog';
import { ConditionPaiement, ConditionPaiementCreate, ConditionPaiementUpdate } from '../types/conditionPaiement';
import { ModePaiement, ModePaiementCreate, ModePaiementUpdate } from '../types/modePaiement';
import { Devis, DevisCreate, DevisUpdate } from '../types/devis';
import {
  DemandeAchat,
  DemandeAchatCreate,
  DemandeAchatUpdate,
  DemandeAchatListResponse,
  DemandeAchatStatusUpdate,
} from '../types/demandeAchat';
import {
  BonCommande,
  BonCommandeCreate,
  BonCommandeUpdate,
  BonCommandeListResponse,
  BonCommandeStatusUpdate,
  BonCommandeFilters,
} from '../types/bonCommande';
import { BonLivraison, BonLivraisonCreate, BonLivraisonUpdate } from '../types/bonLivraison';
import { StockExitNew, StockExitNewCreate, StockExitNewUpdate, StockExitNewListResponse, StockExitPayment, StockExitPaymentSummary } from '../types/stockExitNew';
import { StockReturnNew, StockReturnNewCreate, StockReturnNewUpdate, StockReturnNewListResponse } from '../types/stockReturnNew';
import { Facture, FactureCreate, FactureUpdate, DevisAcompteInfo, AvailableAcompte } from '../types/facture';
import { FactureAvoir, FactureAvoirCreate, FactureAvoirUpdate, FactureDropdown, BonRetourDropdown, FactureItemsForAvoir } from '../types/factureAvoir';
import { FactureProforma, FactureProformaCreate, FactureProformaUpdate, FactureProformaListResponse } from '../types/factureProforma';
import { Encaissement, EncaissementCreate, EncaissementUpdate, EncaissementListResponse, FactureImpayee } from '../types/encaissement';
import { Beneficiaire, BeneficiaireCreate, BeneficiaireUpdate, BeneficiaireListResponse } from '../types/beneficiaire';
import { Decaissement, DecaissementCreate, DecaissementUpdate, DecaissementListResponse } from '../types/decaissement';
import { Atelier, AtelierCreate, AtelierUpdate, AtelierListResponse } from '../types/atelier';
import {
  Machine,
  MachineCreate,
  MachineUpdate,
  MachineListResponse,
  MachineDropdownItem,
  MachineConflictResponse,
  MachineOccupation,
} from '../types/machine';
import { PlanningEntry, PlanningCreate, PlanningUpdate, PlanningListResponse, WeekPlanningResponse } from '../types/planning';
import {
  SuiviPhase, SuiviPhaseCreate, SuiviPhaseUpdate, SuiviPhaseListResponse,
  SuiviPhaseStep, SuiviPhaseStepCreate, SuiviPhaseStepUpdate, SuiviPhaseStepListResponse,
  ProjetServiceSuivi, ProjetServiceSuiviListResponse, ToggleProgressResponse,
  MonSuiviPlanningEntry, MonSuiviListResponse,
} from '../types/suivi';
import {
  Conversation, ConversationList, ConversationCreate,
  ChatMessage, MessageList, ChatUser,
  FileUploadResponse, UnreadCountResponse, MessageSearchResponse
} from '../types/chat';
import {
  Employee, EmployeeCreate, EmployeeUpdate, EmployeeListResponse,
  EmployeeStats, EmployeeDropdownItem, EmployeeDocument, EmployeeDocumentListResponse,
  DocumentType
} from '../types/employee';
import {
  BulletinPaie,
  BulletinPaieCreate,
  BulletinPaieCreateFromCalcul,
  BulletinPaieUpdate,
  BulletinPaieValidate,
  BulletinPaieListResponse,
  BulletinPaieStats,
  BulletinDriftResponse,
  GenerateAllBulletinsResponse,
} from '../types/bulletinPaie';
import {
  MonthlyPointageResponse,
  PointageStats,
  PointageDaySummary,
  PointageEntry,
  PointageEntryCreate,
  PointageEntryUpdate,
  PointageBulkUpdate,
} from '../types/pointage';
import {
  Conge,
  CongeCreate,
  CongeUpdate,
  CongeValidate,
  CongeListResponse,
  EmployeeSoldeResponse,
  RecapitulatifCongeResponse,
} from '../types/conge';
import {
  JourFerie,
  JourFerieCreate,
  JourFerieUpdate,
  JourFerieListResponse,
} from '../types/jourFerie';
import {
  AttestationTravail,
  AttestationTravailCreate,
  AttestationTravailUpdate,
  AttestationTravailListResponse,
} from '../types/attestationTravail';
import {
  AttestationSalaire,
  AttestationSalaireCreate,
  AttestationSalaireUpdate,
  AttestationSalaireListResponse,
} from '../types/attestationSalaire';
import {
  Pret,
  PretCreate,
  PretUpdate,
  PretValidate,
  PretAddPayment,
  PretListResponse,
  PretStats,
  PretHistoriqueResponse,
} from '../types/pret';
import {
  Acompte,
  AcompteCreate,
  AcompteUpdate,
  AcompteValidate,
  AcompteMarkPaid,
  AcompteListResponse,
  AcompteStats,
} from '../types/acompte';
import {
  AutorisationAbsence,
  AutorisationAbsenceCreate,
  AutorisationAbsenceUpdate,
  AutorisationAbsenceValidate,
  AutorisationAbsenceListResponse,
  AutorisationAbsenceStats,
} from '../types/autorisationAbsence';
import {
  SmtpSetting,
  SmtpSettingCreate,
  SmtpSettingUpdate,
  SmtpTestRequest,
  SmtpTestResponse,
} from '../types/smtpSetting';
import {
  PrimeExoneree,
  PrimeExonereeCreate,
  PrimeExonereeUpdate,
  PrimeExonereeListResponse,
  PrimeNonExoneree,
  PrimeNonExonereeCreate,
  PrimeNonExonereeUpdate,
  PrimeNonExonereeListResponse,
  CotisationSociale,
  CotisationSocialeCreate,
  CotisationSocialeUpdate,
  CotisationSocialeListResponse,
  EmployeePrimesUpdate,
  EmployeePrimesResponse,
  PrimeDropdownItem,
  CotisationDropdownItem,
} from '../types/paie';
import {
  EmailEvent,
  EmailEventCreate,
  EmailEventUpdate,
  EmailEventToggle,
  EmailEventTemplateUpdate,
  EmailEventsByModule,
} from '../types/emailEvent';
import {
  EmailQueue,
  EmailQueueListResponse,
  EmailQueueStats,
  EmailQueueFilter,
  EmailQueueManualSend,
  EmailQueueRetryResponse,
} from '../types/emailQueue';
import {
  AppNotification,
  NotificationListResponse,
  NotificationUnreadCountResponse,
  NotificationEvent,
  NotificationEventListResponse,
} from '../types/notification';

// API Base URL from environment variable
// In React (Create React App), environment variables must be prefixed with REACT_APP_
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Important for cookie-based auth
  headers: {
    'Content-Type': 'application/json',
  },
});

// Track if a refresh is in progress and queue for failed requests
let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value?: any) => void;
  reject: (error?: any) => void;
}> = [];

// Process queued requests after refresh
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  
  failedQueue = [];
};

// CSRF token will be managed by AuthContext and passed via headers when needed
// No localStorage storage for security reasons - we use httpOnly cookies

// Loading state handlers (set by LoadingProvider)
let loadingHandlers: {
  incrementRequests: () => void;
  decrementRequests: () => void;
} | null = null;

/**
 * Set loading handlers from LoadingContext
 * This should be called once when the app initializes
 */
export const setLoadingHandlers = (handlers: {
  incrementRequests: () => void;
  decrementRequests: () => void;
}) => {
  loadingHandlers = handlers;
};

// Endpoints excluded from global loading indicator (background/real-time operations)
const LOADING_EXCLUDED_ENDPOINTS = [
  '/api/chat/',           // All chat endpoints (WebSocket, messages, conversations)
  '/api/notifications/',  // Bell badge / list — background resync (e.g. on tab focus); bell has its own local spinner
  '/api/auth/refresh',    // Token refresh (background)
  '/api/audit-logs/pdf-download', // PDF download audit (fire-and-forget)
  '/api/attendance/',     // Biometric attendance: polled every 5s + has its own in-page loading
];

// Check if URL should be excluded from loading indicator
const shouldExcludeFromLoading = (url?: string): boolean => {
  if (!url) return false;
  return LOADING_EXCLUDED_ENDPOINTS.some(endpoint => url.includes(endpoint));
};

// Request interceptor to show loading
api.interceptors.request.use(
  (config) => {
    // Increment loading counter only for non-excluded requests
    if (loadingHandlers && !shouldExcludeFromLoading(config.url)) {
      loadingHandlers.incrementRequests();
    }
    return config;
  },
  (error) => {
    // Decrement on request error (only if not excluded)
    if (loadingHandlers && !shouldExcludeFromLoading(error.config?.url)) {
      loadingHandlers.decrementRequests();
    }
    return Promise.reject(error);
  }
);

// Add response interceptor to handle authentication errors
api.interceptors.response.use(
  (response) => {
    // Decrement loading counter on successful response (only if not excluded)
    if (loadingHandlers && !shouldExcludeFromLoading(response.config?.url)) {
      loadingHandlers.decrementRequests();
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Skip retry for auth endpoints (login, refresh), already retried requests, or non-401 errors
    if (error.response?.status !== 401 ||
        originalRequest.url?.includes('/api/auth/login') ||
        originalRequest.url?.includes('/api/auth/refresh') ||
        originalRequest._retry) {
      // Decrement loading counter for final errors (only if not excluded)
      if (loadingHandlers && !shouldExcludeFromLoading(originalRequest?.url)) {
        loadingHandlers.decrementRequests();
      }
      return Promise.reject(error);
    }

    if (isRefreshing) {
      // If refresh is in progress, queue this request
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(() => {
        // Retry original request after refresh completes
        return api.request(originalRequest);
      }).catch((err) => {
        // Decrement loading counter for queued requests that fail
        if (loadingHandlers) {
          loadingHandlers.decrementRequests();
        }
        return Promise.reject(err);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      // Try to refresh token
      await api.post('/api/auth/refresh');

      // Refresh successful - process queue and retry original request
      processQueue(null, 'refreshed');
      isRefreshing = false;
      return api.request(originalRequest);
      
    } catch (refreshError) {
      // Refresh failed - process queue with error and redirect to login
      processQueue(refreshError, null);
      isRefreshing = false;

      // Decrement loading counter for auth failures
      if (loadingHandlers) {
        loadingHandlers.decrementRequests();
      }

      // Clear auth state and redirect
      console.log('Échec de l\'authentification, redirection vers la page de connexion');

      // Only redirect if we're not already on the login or session-expired page
      if (!window.location.pathname.includes('/login') && !window.location.pathname.includes('/session-expired')) {
        // Use setTimeout to avoid interrupting the current execution
        setTimeout(() => {
          window.location.href = '/login';
        }, 100);
      }

      return Promise.reject(refreshError);
    }
  }
);

export const authAPI = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>('/api/auth/login', credentials);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/api/auth/logout');
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<User>('/api/auth/users/me');
    return response.data;
  },

  refreshToken: async (): Promise<{ csrf_token: string }> => {
    const response = await api.post<{ message: string; csrf_token: string }>('/api/auth/refresh');
    return response.data;
  },

  getCsrfToken: async (): Promise<string> => {
    const response = await api.get<{ csrf_token: string }>('/api/auth/csrf-token');
    return response.data.csrf_token;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>('/api/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  unlockUser: async (userId: number): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>(`/api/auth/unlock-user/${userId}`);
    return response.data;
  },

  resetUserPassword: async (userId: number): Promise<{ message: string; temporary_password: string }> => {
    const response = await api.post<{ message: string; temporary_password: string }>(`/api/auth/reset-password/${userId}`);
    return response.data;
  },
};

/**
 * Deduped `/me` fetch. AuthContext and PermissionContext both need the current
 * user on first load; without this they fire two (×2 in dev StrictMode) separate
 * /me requests. This shares a single in-flight request across all callers, then
 * clears so later revalidations fetch fresh.
 */
let _meInflight: Promise<User> | null = null;
export const fetchMeShared = (): Promise<User> => {
  if (_meInflight) return _meInflight;
  _meInflight = api
    .get<User>('/api/auth/users/me')
    .then((r) => r.data)
    .finally(() => {
      _meInflight = null;
    });
  return _meInflight;
};

export const userAPI = {
  getUsers: async (skip = 0, limit = 1000): Promise<User[]> => {
    const response = await api.get<User[]>(`/api/users?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  getUser: async (userId: number): Promise<User> => {
    const response = await api.get<User>(`/api/users/${userId}`);
    return response.data;
  },

  createUser: async (userData: CreateUserRequest): Promise<User> => {
    const response = await api.post<User>('/api/users', userData);
    return response.data;
  },

  updateUser: async (userId: number, userData: UpdateUserRequest): Promise<User> => {
    const response = await api.put<User>(`/api/users/${userId}`, userData);
    return response.data;
  },

  deleteUser: async (userId: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/api/users/${userId}`);
    return response.data;
  },
};

// Categories API
export const categoriesAPI = {
  getAll: (): Promise<Category[]> =>
    api.get('/api/categories').then(response => response.data),

  getDeleted: (): Promise<Category[]> =>
    api.get('/api/categories/deleted').then(response => response.data),

  create: (category: CategoryCreate): Promise<Category> =>
    api.post('/api/categories', category).then(response => response.data),

  update: (id: number, category: Partial<CategoryCreate>): Promise<Category> =>
    api.put(`/api/categories/${id}`, category).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/categories/${id}`).then(() => {}),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/categories/${id}/restore`).then(response => response.data),
};

// Units API
export const unitsAPI = {
  getAll: (): Promise<Unit[]> =>
    api.get('/api/units').then(response => response.data),

  getDeleted: (): Promise<Unit[]> =>
    api.get('/api/units/deleted').then(response => response.data),

  create: (unit: UnitCreate): Promise<Unit> =>
    api.post('/api/units', unit).then(response => response.data),

  update: (id: number, unit: Partial<UnitCreate>): Promise<Unit> =>
    api.put(`/api/units/${id}`, unit).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/units/${id}`).then(() => {}),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/units/${id}/restore`).then(response => response.data),
};

// Articles API
export interface ArticleListResponse {
  total: number;
  items: Article[];
}

export const articlesAPI = {
  getAll: (skip?: number, limit?: number, search?: string): Promise<Article[]> => {
    const params = new URLSearchParams();
    if (skip !== undefined) params.append('skip', skip.toString());
    if (limit !== undefined) params.append('limit', limit.toString());
    if (search) params.append('search', search);
    return api.get(`/api/articles?${params}`).then(response => response.data.items || response.data);
  },

  // Get all articles for dropdown/autocomplete usage (no pagination)
  getAllForDropdown: (): Promise<Article[]> => {
    return api.get('/api/articles/all').then(response => response.data);
  },

  getPaginated: (skip: number, limit: number, search?: string, extraParams?: Record<string, any>): Promise<ArticleListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (extraParams) {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/articles?${params}`).then(response => response.data);
  },

  getDeleted: (): Promise<Article[]> =>
    api.get('/api/articles/deleted').then(response => response.data),

  getById: (id: number): Promise<Article> =>
    api.get(`/api/articles/${id}`).then(response => response.data),

  search: (reference: string): Promise<Article[]> =>
    api.get(`/api/articles/search?reference=${reference}`).then(response => response.data),

  create: (article: ArticleCreate): Promise<Article> =>
    api.post('/api/articles', article).then(response => response.data),

  update: (id: number, article: ArticleUpdate): Promise<Article> =>
    api.put(`/api/articles/${id}`, article).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/articles/${id}`).then(() => {}),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/articles/${id}/restore`).then(response => response.data),

  getStatistics: (): Promise<{
    articles_count: number;
    categories_count: number;
    units_count: number;
  }> =>
    api.get('/api/articles/statistics').then(response => response.data),
};

// Suppliers API
export const suppliersAPI = {
  getAll: (skip?: number, limit?: number, search?: string, is_active?: boolean, extraParams?: Record<string, any>): Promise<SupplierListResponse> => {
    const params = new URLSearchParams();
    if (skip !== undefined) params.append('skip', skip.toString());
    if (limit !== undefined) params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (is_active !== undefined) params.append('is_active', is_active.toString());
    if (extraParams) {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/suppliers?${params}`).then(response => response.data);
  },

  // Get all active suppliers for dropdown/autocomplete usage (no pagination)
  getAllForDropdown: (): Promise<Supplier[]> =>
    api.get('/api/suppliers/all').then(response => response.data),

  getDeleted: (): Promise<SupplierListResponse> =>
    api.get('/api/suppliers/deleted').then(response => response.data),

  getNextCode: (): Promise<{ code: string }> =>
    api.get('/api/suppliers/next-code').then(response => response.data),

  getById: (id: number): Promise<Supplier> =>
    api.get(`/api/suppliers/${id}`).then(response => response.data),

  getByCode: (code: string): Promise<Supplier> =>
    api.get(`/api/suppliers/code/${code}`).then(response => response.data),

  create: (supplier: CreateSupplierRequest): Promise<Supplier> =>
    api.post('/api/suppliers', supplier).then(response => response.data),

  update: (id: number, supplier: UpdateSupplierRequest): Promise<Supplier> =>
    api.put(`/api/suppliers/${id}`, supplier).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/suppliers/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/suppliers/${id}/restore`).then(response => response.data),

  toggleStatus: (id: number): Promise<{ message: string; is_active: boolean }> =>
    api.post(`/api/suppliers/${id}/toggle-status`).then(response => response.data),
};

// Stock Entries API (Parent-Child Structure with items)
export const stockEntriesAPI = {
  getAll: (supplier_id?: number, start_date?: string, end_date?: string): Promise<StockEntryNew[]> => {
    const params = new URLSearchParams();
    if (supplier_id) params.append('supplier_id', supplier_id.toString());
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    return api.get(`/api/stock-entries?${params}`).then(response => response.data.items || response.data);
  },

  getPaginated: (skip: number, limit: number, search?: string, start_date?: string, end_date?: string, supplier_id?: number, extraParams?: Record<string, any>): Promise<StockEntryNewListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (supplier_id) params.append('supplier_id', supplier_id.toString());
    if (extraParams) {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/stock-entries?${params}`).then(response => response.data);
  },

  getById: (id: number): Promise<StockEntryNew> =>
    api.get(`/api/stock-entries/${id}`).then(response => response.data),

  create: (stockEntry: StockEntryNewCreate): Promise<StockEntryNew> =>
    api.post('/api/stock-entries', stockEntry).then(response => response.data),

  update: (id: number, stockEntry: StockEntryNewUpdate): Promise<StockEntryNew> =>
    api.put(`/api/stock-entries/${id}`, stockEntry).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/stock-entries/${id}`).then(response => response.data),

  getDeleted: (): Promise<StockEntryNew[]> =>
    api.get('/api/stock-entries/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/stock-entries/${id}/restore`).then(response => response.data),

  getNextBlNumber: (): Promise<{ bl_number: string }> =>
    api.get('/api/stock-entries/next-bl-number').then(response => response.data),

  getArticleMaxPrice: (article_id: number): Promise<{ article_id: number; max_price: number }> =>
    api.get(`/api/stock-entries/article/${article_id}/max-price`).then(response => response.data),

  getByBlNumber: (bl_number: string): Promise<StockEntryNew> =>
    api.get(`/api/stock-entries/by-bl/${encodeURIComponent(bl_number)}`).then(response => response.data),
};

// Alias for backwards compatibility
export const stockEntriesNewAPI = stockEntriesAPI;

// Clients API
export const clientsAPI = {
  getAll: (skip?: number, limit?: number, search?: string, is_active?: boolean, extraParams?: Record<string, any>): Promise<ClientListResponse> => {
    const params = new URLSearchParams();
    if (skip !== undefined) params.append('skip', skip.toString());
    if (limit !== undefined) params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (is_active !== undefined) params.append('is_active', is_active.toString());
    if (extraParams) {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/clients?${params}`).then(response => response.data);
  },

  // Get all active clients for dropdown/autocomplete usage (no pagination)
  getAllForDropdown: (): Promise<Client[]> =>
    api.get('/api/clients/all').then(response => response.data),

  getDeleted: (): Promise<ClientListResponse> =>
    api.get('/api/clients/deleted').then(response => response.data),

  getById: (id: number): Promise<Client> =>
    api.get(`/api/clients/${id}`).then(response => response.data),

  getByCode: (code: string): Promise<Client> =>
    api.get(`/api/clients/code/${code}`).then(response => response.data),

  create: (client: ClientCreate): Promise<Client> =>
    api.post('/api/clients', client).then(response => response.data),

  update: (id: number, client: ClientUpdate): Promise<Client> =>
    api.put(`/api/clients/${id}`, client).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/clients/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/clients/${id}/restore`).then(response => response.data),

  toggleStatus: (id: number): Promise<{ message: string; is_active: boolean }> =>
    api.post(`/api/clients/${id}/toggle-status`).then(response => response.data),

  getNextCode: (): Promise<{ code: string }> =>
    api.get('/api/clients/next-code').then(response => response.data),
};

// Services API
export const servicesAPI = {
  getAll: (skip?: number, limit?: number, search?: string, is_active?: boolean, extra?: Record<string, any>): Promise<ServiceListResponse> => {
    const params = new URLSearchParams();
    if (skip !== undefined) params.append('skip', skip.toString());
    if (limit !== undefined) params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (is_active !== undefined) params.append('is_active', is_active.toString());
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => params.append(k, String(x))); return; }
        params.append(k, String(v));
      });
    }
    return api.get(`/api/services?${params}`).then(response => response.data);
  },

  // Get all active services for dropdown/autocomplete usage (no pagination)
  getAllForDropdown: (): Promise<Service[]> =>
    api.get('/api/services/all').then(response => response.data),

  getDeleted: (): Promise<ServiceListResponse> =>
    api.get('/api/services/deleted').then(response => response.data),

  getById: (id: number): Promise<Service> =>
    api.get(`/api/services/${id}`).then(response => response.data),

  getByCode: (code: string): Promise<Service> =>
    api.get(`/api/services/code/${code}`).then(response => response.data),

  create: (service: ServiceCreate): Promise<Service> =>
    api.post('/api/services', service).then(response => response.data),

  update: (id: number, service: ServiceUpdate): Promise<Service> =>
    api.put(`/api/services/${id}`, service).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/services/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/services/${id}/restore`).then(response => response.data),

  toggleStatus: (id: number): Promise<{ message: string; is_active: boolean }> =>
    api.post(`/api/services/${id}/toggle-status`).then(response => response.data),

  getNextCode: (): Promise<{ code: string }> =>
    api.get('/api/services/next-code').then(response => response.data),

  // Comptoir rows only: the travaux of the offre, without prices (empty for other rows)
  getComptoirTravaux: (id: number): Promise<ComptoirProductionTravaux> =>
    api.get(`/api/services/${id}/comptoir-travaux`).then(response => response.data),
};

// Demandeurs API
export const demandeursAPI = {
  getAll: (skip?: number, limit?: number, search?: string, service_id?: number, is_active?: boolean, extra?: Record<string, any>): Promise<DemandeurListResponse> => {
    const params = new URLSearchParams();
    if (skip !== undefined) params.append('skip', skip.toString());
    if (limit !== undefined) params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (service_id !== undefined) params.append('service_id', service_id.toString());
    if (is_active !== undefined) params.append('is_active', is_active.toString());
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => params.append(k, String(x))); return; }
        params.append(k, String(v));
      });
    }
    return api.get(`/api/demandeurs?${params}`).then(response => response.data);
  },

  // Get all active demandeurs for dropdown/autocomplete usage (no pagination)
  getAllForDropdown: (): Promise<Demandeur[]> =>
    api.get('/api/demandeurs/all').then(response => response.data),

  getDeleted: (): Promise<DemandeurListResponse> =>
    api.get('/api/demandeurs/deleted').then(response => response.data),

  getById: (id: number): Promise<Demandeur> =>
    api.get(`/api/demandeurs/${id}`).then(response => response.data),

  create: (demandeur: DemandeurCreate): Promise<Demandeur> =>
    api.post('/api/demandeurs', demandeur).then(response => response.data),

  update: (id: number, demandeur: DemandeurUpdate): Promise<Demandeur> =>
    api.put(`/api/demandeurs/${id}`, demandeur).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/demandeurs/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/demandeurs/${id}/restore`).then(response => response.data),

  toggleStatus: (id: number): Promise<{ message: string; is_active: boolean }> =>
    api.post(`/api/demandeurs/${id}/toggle-status`).then(response => response.data),
};

// Projets API
export const projetsAPI = {
  getAll: (skip?: number, limit?: number, search?: string, status?: string, priorite?: string, client_id?: number, service_id?: number, is_active?: boolean, extra?: Record<string, any>): Promise<ProjetListResponse> => {
    const params = new URLSearchParams();
    if (skip !== undefined) params.append('skip', skip.toString());
    if (limit !== undefined) params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (priorite) params.append('priorite', priorite);
    if (client_id !== undefined) params.append('client_id', client_id.toString());
    if (service_id !== undefined) params.append('service_id', service_id.toString());
    if (is_active !== undefined) params.append('is_active', is_active.toString());
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => params.append(k, String(x))); return; }
        params.append(k, String(v));
      });
    }
    return api.get(`/api/projets?${params}`).then(response => response.data);
  },

  // Get all active projets for dropdown/autocomplete usage (no pagination)
  getAllForDropdown: (): Promise<Projet[]> =>
    api.get('/api/projets/all').then(response => response.data),

  getDeleted: (): Promise<ProjetListResponse> =>
    api.get('/api/projets/deleted').then(response => response.data),

  getById: (id: number): Promise<Projet> =>
    api.get(`/api/projets/${id}`).then(response => response.data),

  create: (projet: ProjetCreate): Promise<Projet> =>
    api.post('/api/projets', projet).then(response => response.data),

  update: (id: number, projet: ProjetUpdate): Promise<Projet> =>
    api.put(`/api/projets/${id}`, projet).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/projets/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/projets/${id}/restore`).then(response => response.data),

  toggleStatus: (id: number): Promise<{ message: string; is_active: boolean }> =>
    api.post(`/api/projets/${id}/toggle-status`).then(response => response.data),

  getNextCode: (): Promise<{ code: string }> =>
    api.get('/api/projets/next-code').then(response => response.data),

  // Comptoir rows only: the travaux of the offre, without prices (empty for other rows)
  getComptoirTravaux: (id: number): Promise<ComptoirProductionTravaux> =>
    api.get(`/api/projets/${id}/comptoir-travaux`).then(response => response.data),
};

// Stock Exits API (Parent-Child Structure with items)
export const stockExitsAPI = {
  getAll: (start_date?: string, end_date?: string, article_id?: number, service_id?: number, client_id?: number): Promise<StockExitNew[]> => {
    const params = new URLSearchParams();
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (article_id) params.append('article_id', article_id.toString());
    if (service_id) params.append('service_id', service_id.toString());
    if (client_id) params.append('client_id', client_id.toString());
    return api.get(`/api/stock-exits?${params}`).then(response => response.data.items || response.data);
  },

  getPaginated: (skip: number, limit: number, search?: string, start_date?: string, end_date?: string, article_id?: number, service_id?: number, client_id?: number, extraParams?: Record<string, any>): Promise<StockExitNewListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (article_id) params.append('article_id', article_id.toString());
    if (service_id) params.append('service_id', service_id.toString());
    if (client_id) params.append('client_id', client_id.toString());
    if (extraParams) {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/stock-exits?${params}`).then(response => response.data);
  },

  getById: (id: number): Promise<StockExitNew> =>
    api.get(`/api/stock-exits/${id}`).then(response => response.data),

  create: (stockExit: StockExitNewCreate): Promise<StockExitNew> =>
    api.post('/api/stock-exits', stockExit).then(response => response.data),

  update: (id: number, stockExit: StockExitNewUpdate): Promise<StockExitNew> =>
    api.put(`/api/stock-exits/${id}`, stockExit).then(response => response.data),

  togglePaymentStatus: (id: number): Promise<{ id: number; previous_status: boolean; new_status: boolean; message: string }> =>
    api.patch(`/api/stock-exits/${id}/payment-status`).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/stock-exits/${id}`).then(response => response.data),

  getDeleted: (): Promise<StockExitNew[]> =>
    api.get('/api/stock-exits/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/stock-exits/${id}/restore`).then(response => response.data),

  getNextBonNumber: (): Promise<{ bon_number: string }> =>
    api.get('/api/stock-exits/next-bon-number').then(response => response.data),

  // Lightweight list of ALL exits (no pagination, no items) for dropdowns
  getAllForDropdown: (): Promise<Array<{ id: number; bon_number: string; date: string; client_id: number | null; client_name?: string | null }>> =>
    api.get('/api/stock-exits/all-for-dropdown').then(response => response.data),

  // Payments recorded later against a stock exit (separate from the advance)
  getPayments: (exitId: number): Promise<StockExitPayment[]> =>
    api.get(`/api/stock-exits/${exitId}/payments`).then(response => response.data),

  addPayment: (exitId: number, data: { amount: number; date?: string }): Promise<StockExitPayment> =>
    api.post(`/api/stock-exits/${exitId}/payments`, data).then(response => response.data),

  updatePayment: (paymentId: number, data: { amount: number; date?: string }): Promise<StockExitPayment> =>
    api.put(`/api/stock-exits/payments/${paymentId}`, data).then(response => response.data),

  deletePayment: (paymentId: number): Promise<void> =>
    api.delete(`/api/stock-exits/payments/${paymentId}`).then(() => {}),

  getPaymentSummary: (params: { client_id?: number; start_date?: string; end_date?: string }): Promise<StockExitPaymentSummary> => {
    const qs = new URLSearchParams();
    if (params.client_id) qs.append('client_id', params.client_id.toString());
    if (params.start_date) qs.append('start_date', params.start_date);
    if (params.end_date) qs.append('end_date', params.end_date);
    return api.get(`/api/stock-exits/payment-summary?${qs}`).then(response => response.data);
  },
};

// Alias for backwards compatibility
export const stockExitsNewAPI = stockExitsAPI;

// Stock Returns API (Parent-Child Structure with items)
export const stockReturnsAPI = {
  getAll: (client_id?: number, start_date?: string, end_date?: string): Promise<StockReturnNew[]> => {
    const params = new URLSearchParams();
    if (client_id) params.append('client_id', client_id.toString());
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    return api.get(`/api/stock-returns?${params}`).then(response => response.data.items || response.data);
  },

  getPaginated: (skip: number, limit: number, search?: string, client_id?: number, start_date?: string, end_date?: string, extraParams?: Record<string, any>): Promise<StockReturnNewListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (client_id) params.append('client_id', client_id.toString());
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (extraParams) {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/stock-returns?${params}`).then(response => response.data);
  },

  getById: (id: number): Promise<StockReturnNew> =>
    api.get(`/api/stock-returns/${id}`).then(response => response.data),

  create: (stockReturn: StockReturnNewCreate): Promise<StockReturnNew> =>
    api.post('/api/stock-returns', stockReturn).then(response => response.data),

  update: (id: number, stockReturn: StockReturnNewUpdate): Promise<StockReturnNew> =>
    api.put(`/api/stock-returns/${id}`, stockReturn).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/stock-returns/${id}`).then(response => response.data),

  getDeleted: (): Promise<StockReturnNew[]> =>
    api.get('/api/stock-returns/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/stock-returns/${id}/restore`).then(response => response.data),

  getNextBonRetourNumber: (): Promise<{ bon_retour_number: string }> =>
    api.get('/api/stock-returns/next-bon-retour-number').then(response => response.data),
};

// Inventories API
export const inventoriesAPI = {
  getAll: (start_date?: string, end_date?: string, article_id?: number): Promise<InventoryRecord[]> => {
    const params = new URLSearchParams();
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (article_id) params.append('article_id', article_id.toString());
    return api.get(`/api/inventories?${params}`).then(response => response.data);
  },
  
  getById: (id: number): Promise<InventoryRecord> => 
    api.get(`/api/inventories/${id}`).then(response => response.data),
  
  getSummary: (): Promise<InventorySummary> => 
    api.get('/api/inventories/summary').then(response => response.data),
  
  calculate: (articleId: number, inventoryDate?: string): Promise<CalculatedInventory> => {
    const params = new URLSearchParams();
    if (inventoryDate) params.append('inventory_date', inventoryDate);
    return api.get(`/api/inventories/calculate/${articleId}?${params}`).then(response => response.data);
  },
  
  batchCalculate: (inventoryDate: string): Promise<{ created_count: number }> =>
    api.post('/api/inventories/batch-calculate', { inventory_date: inventoryDate }).then(response => response.data),

  create: (inventory: InventoryRecordCreate): Promise<InventoryRecord> =>
    api.post('/api/inventories', inventory).then(response => response.data),

  update: (id: number, inventory: InventoryRecordUpdate): Promise<InventoryRecord> =>
    api.put(`/api/inventories/${id}`, inventory).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/inventories/${id}`).then(response => response.data),
  
  getRealTime: (params?: { skip?: number; limit?: number; search?: string; article_id?: number; low_stock_only?: boolean }): Promise<InventoryRecord[]> => {
    const queryParams = new URLSearchParams();
    if (params?.skip) queryParams.append('skip', params.skip.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.article_id) queryParams.append('article_id', params.article_id.toString());
    if (params?.low_stock_only) queryParams.append('low_stock_only', 'true');
    return api.get(`/api/inventories/real-time?${queryParams}`).then(response => response.data.items || response.data);
  },

  getPaginated: (skip: number, limit: number, search?: string, article_id?: number, low_stock_only?: boolean, extraParams?: Record<string, any>): Promise<InventoryListResponse> => {
    const queryParams = new URLSearchParams();
    queryParams.append('skip', skip.toString());
    queryParams.append('limit', limit.toString());
    if (search) queryParams.append('search', search);
    if (article_id) queryParams.append('article_id', article_id.toString());
    if (low_stock_only) queryParams.append('low_stock_only', 'true');
    if (extraParams) {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') queryParams.append(k, String(v));
      });
    }
    return api.get(`/api/inventories/real-time?${queryParams}`).then(response => response.data);
  },
  
  getCurrentStock: (articleId: number): Promise<any> => 
    api.get(`/api/inventories/current-stock/${articleId}`).then(response => response.data),
  
  autoUpdate: (articleId: number, inventoryDate?: string): Promise<any> => {
    const params = new URLSearchParams();
    if (inventoryDate) params.append('inventory_date', inventoryDate);
    return api.post(`/api/inventories/auto-update/${articleId}?${params}`).then(response => response.data);
  },
};

// Simplified API functions for components (using /all endpoints for dropdowns)
export const getClients = () => clientsAPI.getAllForDropdown();
export const createClient = (data: Omit<Client, 'id'>) => clientsAPI.create(data);
export const updateClient = (id: number, data: Client) => clientsAPI.update(id, data);
export const deleteClient = (id: number) => clientsAPI.delete(id).then(() => {});

export const getServices = () => servicesAPI.getAllForDropdown();
export const createService = (data: ServiceCreate) => servicesAPI.create(data);
export const updateService = (id: number, data: ServiceUpdate) => servicesAPI.update(id, data);
export const deleteService = (id: number) => servicesAPI.delete(id).then(() => {});

export const getDemandeurs = () => demandeursAPI.getAllForDropdown();
export const createDemandeur = (data: Omit<Demandeur, 'id'>) => demandeursAPI.create(data);
export const updateDemandeur = (id: number, data: Demandeur) => demandeursAPI.update(id, data);
export const deleteDemandeur = (id: number) => demandeursAPI.delete(id).then(() => {});

export const getProjets = () => projetsAPI.getAllForDropdown();
export const createProjet = (data: ProjetCreate) => projetsAPI.create(data);
export const updateProjet = (id: number, data: ProjetUpdate) => projetsAPI.update(id, data);
export const deleteProjet = (id: number) => projetsAPI.delete(id).then(() => {});

// Articles simplified functions (for backward compatibility - returns all items)
export const getArticles = () => articlesAPI.getAllForDropdown();
export const createArticle = (data: ArticleCreate) => articlesAPI.create(data);
export const updateArticle = (id: number, data: ArticleUpdate) => articlesAPI.update(id, data);
export const deleteArticle = (id: number) => articlesAPI.delete(id).then(() => {});

// Stock exits simplified functions
export const getStockExits = (params?: { start_date?: string; end_date?: string; article_id?: number; service_id?: number; client_id?: number }) =>
  stockExitsAPI.getAll(params?.start_date, params?.end_date, params?.article_id, params?.service_id, params?.client_id);
export const createStockExit = (data: StockExitNewCreate) => stockExitsAPI.create(data);
export const updateStockExit = (id: number, data: StockExitNewUpdate) => stockExitsAPI.update(id, data);
export const toggleStockExitPaymentStatus = (id: number) => stockExitsAPI.togglePaymentStatus(id);
export const deleteStockExit = (id: number) => stockExitsAPI.delete(id).then(() => {});

// Inventories simplified functions
export const getInventories = (params?: { start_date?: string; end_date?: string; article_id?: number }) => 
  inventoriesAPI.getAll(params?.start_date, params?.end_date, params?.article_id);
export const getInventorySummary = () => inventoriesAPI.getSummary();
export const calculateInventory = (articleId: number, inventoryDate?: string) => inventoriesAPI.calculate(articleId, inventoryDate);
export const batchCalculateInventory = (inventoryDate: string) => inventoriesAPI.batchCalculate(inventoryDate);
export const createInventory = (data: InventoryRecordCreate) => inventoriesAPI.create(data);
export const deleteInventory = (id: number) => inventoriesAPI.delete(id).then(() => {});
export const getRealTimeInventory = (params?: { skip?: number; limit?: number; article_id?: number; low_stock_only?: boolean }) => inventoriesAPI.getRealTime(params);
export const getCurrentStock = (articleId: number) => inventoriesAPI.getCurrentStock(articleId);
export const autoUpdateInventory = (articleId: number, inventoryDate?: string) => inventoriesAPI.autoUpdate(articleId, inventoryDate);

// Stock entries simplified functions
export const createStockEntry = (data: StockEntryNewCreate) => stockEntriesAPI.create(data);

// Audit logs API
export const auditLogsAPI = {
  getAll: async (
    page: number = 1,
    pageSize: number = 50,
    filters?: AuditLogFilter
  ): Promise<AuditLogPagination> => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('page_size', pageSize.toString());

    if (filters) {
      if (filters.user_id) params.append('user_id', filters.user_id.toString());
      if (filters.action) params.append('action', filters.action);
      if (filters.entity_type) params.append('entity_type', filters.entity_type);
      if (filters.entity_id) params.append('entity_id', filters.entity_id.toString());
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      if (filters.search) params.append('search', filters.search);
      if (filters.user_email) params.append('user_email', filters.user_email);
      if (filters.ip_address) params.append('ip_address', filters.ip_address);
    }

    const response = await api.get(`/api/audit-logs?${params.toString()}`);
    return response.data;
  },

  getEntityHistory: async (entityType: string, entityId: number): Promise<AuditLog[]> => {
    const response = await api.get(`/api/audit-logs/entity/${entityType}/${entityId}`);
    return response.data;
  },

  getUserActivity: async (userId: number, limit: number = 100): Promise<AuditLog[]> => {
    const response = await api.get(`/api/audit-logs/user/${userId}?limit=${limit}`);
    return response.data;
  },

  getActions: async (): Promise<string[]> => {
    const response = await api.get('/api/audit-logs/actions');
    return response.data;
  },

  getEntityTypes: async (): Promise<string[]> => {
    const response = await api.get('/api/audit-logs/entity-types');
    return response.data;
  },

  logPdfDownload: (entityType: string, entityId: number, description?: string): void => {
    api.post('/api/audit-logs/pdf-download', {
      entity_type: entityType,
      entity_id: entityId,
      description,
    }).catch(() => {});
  },
};

// Conditions Paiement API
export const conditionsPaiementAPI = {
  getAll: (): Promise<ConditionPaiement[]> =>
    api.get('/api/conditions-paiement').then(response => response.data),

  getById: (id: number): Promise<ConditionPaiement> =>
    api.get(`/api/conditions-paiement/${id}`).then(response => response.data),

  create: (condition: ConditionPaiementCreate): Promise<ConditionPaiement> =>
    api.post('/api/conditions-paiement', condition).then(response => response.data),

  update: (id: number, condition: ConditionPaiementUpdate): Promise<ConditionPaiement> =>
    api.put(`/api/conditions-paiement/${id}`, condition).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/conditions-paiement/${id}`).then(() => {}),

  getDeleted: (): Promise<ConditionPaiement[]> =>
    api.get('/api/conditions-paiement/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/conditions-paiement/${id}/restore`).then(response => response.data),
};

// Modes Paiement API
export const modesPaiementAPI = {
  getAll: (): Promise<ModePaiement[]> =>
    api.get('/api/modes-paiement').then(response => response.data),

  getById: (id: number): Promise<ModePaiement> =>
    api.get(`/api/modes-paiement/${id}`).then(response => response.data),

  create: (mode: ModePaiementCreate): Promise<ModePaiement> =>
    api.post('/api/modes-paiement', mode).then(response => response.data),

  update: (id: number, mode: ModePaiementUpdate): Promise<ModePaiement> =>
    api.put(`/api/modes-paiement/${id}`, mode).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/modes-paiement/${id}`).then(() => {}),

  getDeleted: (): Promise<ModePaiement[]> =>
    api.get('/api/modes-paiement/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/modes-paiement/${id}/restore`).then(response => response.data),
};

// Devis API
export interface DevisListResponse {
  total: number;
  items: Devis[];
}

export const devisAPI = {
  /** DESSINATEUR users, for « Envoyer au bureau d'études » at the validation */
  dessinateurs: (): Promise<{ id: number; full_name: string }[]> =>
    api.get('/api/devis/dessinateurs').then(r => r.data),
  getAll: (status?: string, client_id?: number, search?: string, user_id?: number): Promise<Devis[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (client_id) params.append('client_id', client_id.toString());
    if (search) params.append('search', search);
    if (user_id) params.append('user_id', user_id.toString());
    return api.get(`/api/devis?${params}`).then(response => response.data.items || response.data);
  },

  // Get all active devis for dropdown/autocomplete usage (no pagination)
  getAllForDropdown: (status?: string, client_id?: number): Promise<Devis[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (client_id) params.append('client_id', client_id.toString());
    const qs = params.toString();
    return api.get(`/api/devis/all-for-dropdown${qs ? `?${qs}` : ''}`).then(response => response.data);
  },

  getPaginated: (
    skip: number,
    limit: number,
    search?: string,
    status?: string,
    client_id?: number,
    user_id?: number,
    extra?: Record<string, any>
  ): Promise<DevisListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (client_id) params.append('client_id', client_id.toString());
    if (user_id) params.append('user_id', user_id.toString());
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/devis?${params}`).then(response => response.data);
  },

  getById: (id: number): Promise<Devis> =>
    api.get(`/api/devis/${id}`).then(response => response.data),

  create: (devis: DevisCreate): Promise<Devis> =>
    api.post('/api/devis', devis).then(response => response.data),

  update: (id: number, devis: DevisUpdate): Promise<Devis> =>
    api.put(`/api/devis/${id}`, devis).then(response => response.data),

  updateStatus: (id: number, status: string): Promise<{ message: string }> =>
    api.patch(`/api/devis/${id}/status?status=${status}`).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/devis/${id}/`).then(response => response.data),

  getDeleted: (): Promise<Devis[]> =>
    api.get('/api/devis/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/devis/${id}/restore`).then(response => response.data),
};

// Demandes d'Achat API
export interface DemandeAchatFilters {
  reference?: string;
  designation?: string;
  statuses?: string[];
  user_ids?: number[];
  projet_ids?: number[];
  start_date?: string;
  end_date?: string;
  unlinked?: boolean;
}

export const demandesAchatAPI = {
  getPaginated: (
    skip: number,
    limit: number,
    search?: string,
    filters?: DemandeAchatFilters,
  ): Promise<DemandeAchatListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (filters) {
      if (filters.reference) params.append('reference', filters.reference);
      if (filters.designation) params.append('designation', filters.designation);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      filters.statuses?.forEach((s) => params.append('statuses', s));
      filters.user_ids?.forEach((u) => params.append('user_ids', u.toString()));
      filters.projet_ids?.forEach((p) => params.append('projet_ids', p.toString()));
      if (filters.unlinked) params.append('unlinked', 'true');
    }
    return api.get(`/api/demande-achats?${params}`).then(response => response.data);
  },

  getById: (id: number): Promise<DemandeAchat> =>
    api.get(`/api/demande-achats/${id}`).then(response => response.data),

  getNextReference: (dateStr?: string): Promise<{ reference: string }> => {
    const params = dateStr ? `?date=${encodeURIComponent(dateStr)}` : '';
    return api.get(`/api/demande-achats/next-reference${params}`).then(r => r.data);
  },

  create: (data: DemandeAchatCreate): Promise<DemandeAchat> =>
    api.post('/api/demande-achats', data).then(response => response.data),

  update: (id: number, data: DemandeAchatUpdate): Promise<DemandeAchat> =>
    api.put(`/api/demande-achats/${id}`, data).then(response => response.data),

  updateStatus: (id: number, payload: DemandeAchatStatusUpdate): Promise<DemandeAchat> =>
    api.patch(`/api/demande-achats/${id}/status`, payload).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/demande-achats/${id}`).then(response => response.data),

  getDeleted: (): Promise<DemandeAchat[]> =>
    api.get('/api/demande-achats/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/demande-achats/${id}/restore`).then(response => response.data),
};

// Bons de Commande API
export const bonsCommandeAPI = {
  getPaginated: (
    skip: number,
    limit: number,
    search?: string,
    filters?: BonCommandeFilters,
  ): Promise<BonCommandeListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (filters) {
      if (filters.reference) params.append('reference', filters.reference);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      if (filters.demande_achat_id) params.append('demande_achat_id', filters.demande_achat_id.toString());
      filters.statuses?.forEach((s) => params.append('statuses', s));
      filters.supplier_ids?.forEach((s) => params.append('supplier_ids', s.toString()));
      filters.user_ids?.forEach((u) => params.append('user_ids', u.toString()));
    }
    return api.get(`/api/bons-commande?${params}`).then(response => response.data);
  },

  getById: (id: number): Promise<BonCommande> =>
    api.get(`/api/bons-commande/${id}`).then(response => response.data),

  getNextReference: (dateStr?: string): Promise<{ reference: string }> => {
    const params = dateStr ? `?date=${encodeURIComponent(dateStr)}` : '';
    return api.get(`/api/bons-commande/next-reference${params}`).then(r => r.data);
  },

  create: (data: BonCommandeCreate): Promise<BonCommande> =>
    api.post('/api/bons-commande', data).then(response => response.data),

  update: (id: number, data: BonCommandeUpdate): Promise<BonCommande> =>
    api.put(`/api/bons-commande/${id}`, data).then(response => response.data),

  updateStatus: (id: number, payload: BonCommandeStatusUpdate): Promise<BonCommande> =>
    api.patch(`/api/bons-commande/${id}/status`, payload).then(response => response.data),

  markReceived: (id: number): Promise<BonCommande> =>
    api.post(`/api/bons-commande/${id}/mark-received`).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/bons-commande/${id}`).then(response => response.data),

  getDeleted: (): Promise<BonCommande[]> =>
    api.get('/api/bons-commande/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/bons-commande/${id}/restore`).then(response => response.data),
};

// Bon de Livraison API
export interface BonLivraisonListResponse {
  total: number;
  items: BonLivraison[];
}

export const bonsLivraisonAPI = {
  getAll: (status?: string, client_id?: number, search?: string): Promise<BonLivraison[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (client_id) params.append('client_id', client_id.toString());
    if (search) params.append('search', search);
    return api.get(`/api/bons-livraison?${params}`).then(response => response.data.items || response.data);
  },

  getPaginated: (
    skip: number,
    limit: number,
    search?: string,
    status?: string,
    client_id?: number,
    user_id?: number,
    extra?: Record<string, any>
  ): Promise<BonLivraisonListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (client_id) params.append('client_id', client_id.toString());
    if (user_id) params.append('user_id', user_id.toString());
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/bons-livraison?${params}`).then(response => response.data);
  },

  getById: (id: number): Promise<BonLivraison> =>
    api.get(`/api/bons-livraison/${id}`).then(response => response.data),

  create: (bl: BonLivraisonCreate): Promise<BonLivraison> =>
    api.post('/api/bons-livraison', bl).then(response => response.data),

  update: (id: number, bl: BonLivraisonUpdate): Promise<BonLivraison> =>
    api.put(`/api/bons-livraison/${id}`, bl).then(response => response.data),

  updateStatus: (id: number, status: string): Promise<{ message: string }> =>
    api.patch(`/api/bons-livraison/${id}/status?status=${status}`).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/bons-livraison/${id}`).then(response => response.data),

  getDeleted: (): Promise<BonLivraison[]> =>
    api.get('/api/bons-livraison/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/bons-livraison/${id}/restore`).then(response => response.data),

  // Get available BLs for a client (not used in any facture)
  getAvailableForClient: (clientId: number, factureId?: number): Promise<BonLivraison[]> => {
    const params = new URLSearchParams();
    if (factureId) params.append('facture_id', factureId.toString());
    return api.get(`/api/bons-livraison/client/${clientId}/available?${params}`).then(response => response.data);
  },
};

// Factures API
export const facturesAPI = {
  getAll: (): Promise<Facture[]> =>
    api.get('/api/factures?limit=1000').then(response => response.data.items || response.data),

  getPaginated: (
    skip: number = 0,
    limit: number = 100,
    search?: string,
    status?: string,
    user_id?: number,
    filters?: {
      reference?: string;
      type?: string;
      date_from?: string;
      date_to?: string;
      client_id?: number;
      bc_numero?: string;
      bl_reference?: string;
      designation?: string;
      montant_min?: number;
      montant_max?: number;
    }
  ): Promise<{ items: Facture[]; total: number; summary: { chiffre_affaires: number; total_encaisse: number; total_en_cours: number } }> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (user_id) params.append('user_id', user_id.toString());
    if (filters?.reference) params.append('reference', filters.reference);
    if (filters?.type) params.append('type', filters.type);
    if (filters?.date_from) params.append('date_from', filters.date_from);
    if (filters?.date_to) params.append('date_to', filters.date_to);
    if (filters?.client_id) params.append('client_id', filters.client_id.toString());
    if (filters?.bc_numero) params.append('bc_numero', filters.bc_numero);
    if (filters?.bl_reference) params.append('bl_reference', filters.bl_reference);
    if (filters?.designation) params.append('designation', filters.designation);
    if (filters?.montant_min !== undefined) params.append('montant_min', filters.montant_min.toString());
    if (filters?.montant_max !== undefined) params.append('montant_max', filters.montant_max.toString());
    return api.get(`/api/factures?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<Facture> =>
    api.get(`/api/factures/${id}`).then(response => response.data),

  getDeleted: (): Promise<Facture[]> =>
    api.get('/api/factures/deleted').then(response => response.data),

  create: (data: FactureCreate): Promise<Facture> =>
    api.post('/api/factures', data).then(response => response.data),

  update: (id: number, data: FactureUpdate): Promise<Facture> =>
    api.put(`/api/factures/${id}`, data).then(response => response.data),

  updateStatus: (id: number, status: string): Promise<{ message: string }> =>
    api.patch(`/api/factures/${id}/status?status=${status}`).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/factures/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/factures/${id}/restore`).then(response => response.data),

  // Acompte endpoints
  getDevisAcompteInfo: (devisId: number): Promise<DevisAcompteInfo> =>
    api.get(`/api/factures/devis/${devisId}/acompte-info`).then(response => response.data),

  getAvailableAcomptes: (clientId: number, factureId?: number): Promise<AvailableAcompte[]> => {
    const params = new URLSearchParams();
    if (factureId) params.append('facture_id', factureId.toString());
    const qs = params.toString();
    return api.get(`/api/factures/client/${clientId}/available-acomptes${qs ? `?${qs}` : ''}`).then(response => response.data);
  },

  // Compte Client endpoints
  getClientSituations: (clientId: number): Promise<string[]> =>
    api.get(`/api/factures/client/${clientId}/situations`).then(response => response.data),

  getClientSummary: (clientId: number): Promise<{
    total_payee: number;
    total_en_cours: number;
    total_impayee: number;
    total_avoir: number;
    plafond_fixe: number;
    plafond_depasse: number;
    chiffre_affaires: number;
  }> =>
    api.get(`/api/factures/client/${clientId}/summary`).then(response => response.data),

  getByClientId: (
    clientId: number,
    skip: number = 0,
    limit: number = 100,
    situation?: string
  ): Promise<{ items: Facture[]; total: number }> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    params.append('client_id', clientId.toString());
    if (situation) params.append('status', situation);
    return api.get(`/api/factures?${params.toString()}`).then(response => response.data);
  },
};

// Factures Avoir API
export const facturesAvoirAPI = {
  getAll: (): Promise<FactureAvoir[]> =>
    api.get('/api/factures-avoir?limit=1000').then(response => response.data.items || response.data),

  getPaginated: (
    skip: number = 0,
    limit: number = 100,
    search?: string,
    status?: string,
    user_id?: number,
    client_id?: number,
    extra?: Record<string, any>
  ): Promise<{ items: FactureAvoir[]; total: number }> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (user_id) params.append('user_id', user_id.toString());
    if (client_id) params.append('client_id', client_id.toString());
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/factures-avoir?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<FactureAvoir> =>
    api.get(`/api/factures-avoir/${id}`).then(response => response.data),

  getDeleted: (): Promise<FactureAvoir[]> =>
    api.get('/api/factures-avoir/deleted').then(response => response.data),

  create: (data: FactureAvoirCreate): Promise<FactureAvoir> =>
    api.post('/api/factures-avoir', data).then(response => response.data),

  update: (id: number, data: FactureAvoirUpdate): Promise<FactureAvoir> =>
    api.put(`/api/factures-avoir/${id}`, data).then(response => response.data),

  updateStatus: (id: number, status: string): Promise<{ message: string }> =>
    api.patch(`/api/factures-avoir/${id}/status?status=${status}`).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/factures-avoir/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/factures-avoir/${id}/restore`).then(response => response.data),

  // Get factures for a client (for dropdown in form)
  getClientFactures: (clientId: number): Promise<FactureDropdown[]> =>
    api.get(`/api/factures-avoir/client/${clientId}/factures`).then(response => response.data),

  // Get bons de retour for a client (for dropdown in form)
  getClientBonsRetour: (clientId: number): Promise<BonRetourDropdown[]> =>
    api.get(`/api/factures-avoir/client/${clientId}/bons-retour`).then(response => response.data),

  // Get items from a facture (for creating avoir)
  getFactureItems: (factureId: number): Promise<FactureItemsForAvoir> =>
    api.get(`/api/factures-avoir/facture/${factureId}/items`).then(response => response.data),

  // Get factures avoir by client ID (for compte client)
  getByClientId: (
    clientId: number,
    skip: number = 0,
    limit: number = 100
  ): Promise<{ items: FactureAvoir[]; total: number }> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    params.append('client_id', clientId.toString());
    return api.get(`/api/factures-avoir?${params.toString()}`).then(response => response.data);
  },
};

// Factures Proforma API
export const facturesProformaAPI = {
  getPaginated: (
    skip: number = 0,
    limit: number = 100,
    search?: string,
    status?: string,
    user_id?: number,
    client_id?: number,
    extra?: Record<string, any>
  ): Promise<FactureProformaListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (user_id) params.append('user_id', user_id.toString());
    if (client_id) params.append('client_id', client_id.toString());
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
      });
    }
    return api.get(`/api/factures-proforma?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<FactureProforma> =>
    api.get(`/api/factures-proforma/${id}`).then(response => response.data),

  create: (data: FactureProformaCreate): Promise<FactureProforma> =>
    api.post('/api/factures-proforma', data).then(response => response.data),

  update: (id: number, data: FactureProformaUpdate): Promise<FactureProforma> =>
    api.put(`/api/factures-proforma/${id}`, data).then(response => response.data),

  updateStatus: (id: number, status: string): Promise<{ message: string }> =>
    api.patch(`/api/factures-proforma/${id}/status?status=${status}`).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/factures-proforma/${id}`).then(response => response.data),

  getDeleted: (): Promise<FactureProforma[]> =>
    api.get('/api/factures-proforma/deleted').then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/factures-proforma/${id}/restore`).then(response => response.data),
};

// Encaissements API
export const encaissementsAPI = {
  getAll: (): Promise<Encaissement[]> =>
    api.get('/api/encaissements?limit=1000').then(response => response.data.items || response.data),

  getPaginated: (
    skip: number = 0,
    limit: number = 100,
    search?: string,
    client_id?: number,
    service_id?: number,
    motif?: string,
    type_encaissement?: string,
    status?: string,
    // Column filters
    filters?: {
      date_from?: string;
      date_to?: string;
      echeance_from?: string;
      echeance_to?: string;
      mode_paiement_id?: number;
      montant_min?: number;
      montant_max?: number;
      libelle?: string;
      reference_paiement?: string;
      projet_id?: number;
      facture_id?: number;
      devis_id?: number;
    }
  ): Promise<EncaissementListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (client_id) params.append('client_id', client_id.toString());
    if (service_id) params.append('service_id', service_id.toString());
    if (motif) params.append('motif', motif);
    if (type_encaissement) params.append('type_encaissement', type_encaissement);
    if (status) params.append('status', status);
    // Column filters
    if (filters) {
      if (filters.date_from) params.append('date_from', filters.date_from);
      if (filters.date_to) params.append('date_to', filters.date_to);
      if (filters.echeance_from) params.append('echeance_from', filters.echeance_from);
      if (filters.echeance_to) params.append('echeance_to', filters.echeance_to);
      if (filters.mode_paiement_id) params.append('mode_paiement_id', filters.mode_paiement_id.toString());
      if (filters.montant_min !== undefined && filters.montant_min !== null) params.append('montant_min', filters.montant_min.toString());
      if (filters.montant_max !== undefined && filters.montant_max !== null) params.append('montant_max', filters.montant_max.toString());
      if (filters.libelle) params.append('libelle', filters.libelle);
      if (filters.reference_paiement) params.append('reference_paiement', filters.reference_paiement);
      if (filters.projet_id) params.append('projet_id', filters.projet_id.toString());
      if (filters.facture_id) params.append('facture_id', filters.facture_id.toString());
      if (filters.devis_id) params.append('devis_id', filters.devis_id.toString());
    }
    return api.get(`/api/encaissements?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<Encaissement> =>
    api.get(`/api/encaissements/${id}`).then(response => response.data),

  getDeleted: (): Promise<Encaissement[]> =>
    api.get('/api/encaissements/deleted').then(response => response.data),

  create: (data: EncaissementCreate): Promise<Encaissement> =>
    api.post('/api/encaissements', data).then(response => response.data),

  update: (id: number, data: EncaissementUpdate): Promise<Encaissement> =>
    api.put(`/api/encaissements/${id}`, data).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/encaissements/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/encaissements/${id}/restore`).then(response => response.data),

  // Get unpaid factures for a client
  getClientUnpaidFactures: (clientId: number): Promise<FactureImpayee[]> =>
    api.get(`/api/encaissements/client/${clientId}/factures-impayees`).then(response => response.data),

  // Get total already encaissé for a devis or facture
  getTotalEncaisse: (params: { devis_id?: number; facture_id?: number; exclude_id?: number }): Promise<{ total_encaisse: number }> => {
    const searchParams = new URLSearchParams();
    if (params.devis_id) searchParams.append('devis_id', params.devis_id.toString());
    if (params.facture_id) searchParams.append('facture_id', params.facture_id.toString());
    if (params.exclude_id) searchParams.append('exclude_id', params.exclude_id.toString());
    return api.get(`/api/encaissements/total-encaisse?${searchParams}`).then(response => response.data);
  },
};

// Beneficiaires API
export const beneficiairesAPI = {
  getAll: (): Promise<Beneficiaire[]> =>
    api.get('/api/beneficiaires?limit=1000').then(response => response.data.items || response.data),

  getPaginated: (
    skip: number = 0,
    limit: number = 100,
    search?: string,
    type?: string,
    extra?: Record<string, any>
  ): Promise<BeneficiaireListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (type) params.append('type', type);
    if (extra) {
      Object.entries(extra).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => params.append(k, String(x))); return; }
        params.append(k, String(v));
      });
    }
    return api.get(`/api/beneficiaires?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<Beneficiaire> =>
    api.get(`/api/beneficiaires/${id}`).then(response => response.data),

  getDeleted: (): Promise<Beneficiaire[]> =>
    api.get('/api/beneficiaires/deleted').then(response => response.data),

  create: (data: BeneficiaireCreate): Promise<Beneficiaire> =>
    api.post('/api/beneficiaires', data).then(response => response.data),

  update: (id: number, data: BeneficiaireUpdate): Promise<Beneficiaire> =>
    api.put(`/api/beneficiaires/${id}`, data).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/beneficiaires/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/beneficiaires/${id}/restore`).then(response => response.data),
};

// Decaissements API
export const decaissementsAPI = {
  getAll: (): Promise<Decaissement[]> =>
    api.get('/api/decaissements?limit=1000').then(response => response.data.items || response.data),

  getPaginated: (
    skip: number = 0,
    limit: number = 100,
    search?: string,
    projet_id?: number,
    beneficiaire_type?: string,
    motif?: string,
    status?: string,
    // Column filters
    filters?: {
      date_from?: string;
      date_to?: string;
      echeance_from?: string;
      echeance_to?: string;
      mode_paiement_id?: number;
      montant_min?: number;
      montant_max?: number;
      libelle?: string;
      piece_justificatif?: string;
      reference_paiement?: string;
      fournisseur_id?: number;
      beneficiaire_id?: number;
    }
  ): Promise<DecaissementListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (projet_id) params.append('projet_id', projet_id.toString());
    if (beneficiaire_type) params.append('beneficiaire_type', beneficiaire_type);
    if (motif) params.append('motif', motif);
    if (status) params.append('status', status);
    // Column filters
    if (filters) {
      if (filters.date_from) params.append('date_from', filters.date_from);
      if (filters.date_to) params.append('date_to', filters.date_to);
      if (filters.echeance_from) params.append('echeance_from', filters.echeance_from);
      if (filters.echeance_to) params.append('echeance_to', filters.echeance_to);
      if (filters.mode_paiement_id) params.append('mode_paiement_id', filters.mode_paiement_id.toString());
      if (filters.montant_min !== undefined && filters.montant_min !== null) params.append('montant_min', filters.montant_min.toString());
      if (filters.montant_max !== undefined && filters.montant_max !== null) params.append('montant_max', filters.montant_max.toString());
      if (filters.libelle) params.append('libelle', filters.libelle);
      if (filters.piece_justificatif) params.append('piece_justificatif', filters.piece_justificatif);
      if (filters.reference_paiement) params.append('reference_paiement', filters.reference_paiement);
      if (filters.fournisseur_id) params.append('fournisseur_id', filters.fournisseur_id.toString());
      if (filters.beneficiaire_id) params.append('beneficiaire_id', filters.beneficiaire_id.toString());
    }
    return api.get(`/api/decaissements?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<Decaissement> =>
    api.get(`/api/decaissements/${id}`).then(response => response.data),

  getDeleted: (): Promise<Decaissement[]> =>
    api.get('/api/decaissements/deleted').then(response => response.data),

  create: (data: DecaissementCreate): Promise<Decaissement> =>
    api.post('/api/decaissements', data).then(response => response.data),

  update: (id: number, data: DecaissementUpdate): Promise<Decaissement> =>
    api.put(`/api/decaissements/${id}`, data).then(response => response.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/decaissements/${id}`).then(response => response.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/decaissements/${id}/restore`).then(response => response.data),
};

// Rapprochement Bancaire API
export interface RapprochementItem {
  id: number;
  operation_type: 'encaissement' | 'decaissement';
  reference: string;
  date: string;
  libelle: string;
  source: string;
  type_operation: string;
  mode_paiement_id: number;
  mode_paiement_nom: string;
  reference_paiement: string;
  montant: number;
  date_echeance: string | null;
  signe: '+' | '-';
  status: string;
  created_at: string;
}

export interface RapprochementSummary {
  total_encaissements: number;
  total_decaissements: number;
  solde: number;
}

export interface RapprochementListResponse {
  total: number;
  items: RapprochementItem[];
  summary: RapprochementSummary;
}

export const rapprochementBancaireAPI = {
  getPaginated: (
    skip: number = 0,
    limit: number = 100,
    search?: string,
    date_debut?: string,
    date_fin?: string,
    operation_type?: string
  ): Promise<RapprochementListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    if (date_debut) params.append('date_debut', date_debut);
    if (date_fin) params.append('date_fin', date_fin);
    if (operation_type) params.append('operation_type', operation_type);
    return api.get(`/api/rapprochement-bancaire?${params.toString()}`).then(response => response.data);
  },
};

// Tresorerie Types
export interface TresorerieModeTotal {
  performant: number;
  encours: number;
  total: number;
}

export interface TresorerieTotals {
  general: TresorerieModeTotal;
  virement: TresorerieModeTotal;
  cheque: TresorerieModeTotal;
  lcn: TresorerieModeTotal;
  espece: TresorerieModeTotal;
}

export interface TresorerieResponse {
  encaissements: TresorerieTotals;
  decaissements: TresorerieTotals;
  solde: {
    performant: number;
    encours: number;
    total: number;
  };
}

export const tresorerieAPI = {
  get: (): Promise<TresorerieResponse> =>
    api.get('/api/tresorerie').then(response => response.data),
};

// Ateliers API
export const ateliersAPI = {
  getAll: (skip: number = 0, limit: number = 1000, search?: string): Promise<AtelierListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    return api.get(`/api/ateliers?${params.toString()}`).then(response => response.data);
  },

  getAllForDropdown: (): Promise<{ id: number; code: string; name: string }[]> =>
    api.get('/api/ateliers/all-for-dropdown').then(response => response.data),

  getNextCode: (): Promise<{ code: string }> =>
    api.get('/api/ateliers/next-code').then(response => response.data),

  getById: (id: number): Promise<Atelier> =>
    api.get(`/api/ateliers/${id}`).then(response => response.data),

  getDeleted: (): Promise<AtelierListResponse> =>
    api.get('/api/ateliers/deleted').then(response => response.data),

  create: (data: AtelierCreate): Promise<Atelier> =>
    api.post('/api/ateliers', data).then(response => response.data),

  update: (id: number, data: AtelierUpdate): Promise<Atelier> =>
    api.put(`/api/ateliers/${id}`, data).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/ateliers/${id}`).then(response => response.data),

  restore: (id: number): Promise<void> =>
    api.post(`/api/ateliers/${id}/restore`).then(response => response.data),
};

// Machines API
export const machineAPI = {
  getOccupation: (): Promise<MachineOccupation> =>
    api.get('/api/machines/occupation').then(r => r.data),

  getAll: (
    skip: number = 0,
    limit: number = 1000,
    atelier_id?: number,
    status?: string,
    search?: string
  ): Promise<MachineListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (atelier_id) params.append('atelier_id', atelier_id.toString());
    if (status) params.append('status', status);
    if (search) params.append('search', search);
    return api.get(`/api/machines?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<Machine> =>
    api.get(`/api/machines/${id}`).then(response => response.data),

  getDeleted: (): Promise<MachineListResponse> =>
    api.get('/api/machines/deleted').then(response => response.data),

  getNextCode: (): Promise<{ code: string }> =>
    api.get('/api/machines/next-code').then(response => response.data),

  getByAtelier: (
    atelier_id: number,
    include_unavailable: boolean = false
  ): Promise<MachineDropdownItem[]> => {
    const params = new URLSearchParams();
    if (include_unavailable) params.append('include_unavailable', 'true');
    const qs = params.toString();
    return api
      .get(`/api/machines/by-atelier/${atelier_id}${qs ? `?${qs}` : ''}`)
      .then(response => response.data);
  },

  create: (data: MachineCreate): Promise<Machine> =>
    api.post('/api/machines', data).then(response => response.data),

  update: (id: number, data: MachineUpdate): Promise<Machine> =>
    api.put(`/api/machines/${id}`, data).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/machines/${id}`).then(response => response.data),

  restore: (id: number): Promise<void> =>
    api.post(`/api/machines/${id}/restore`).then(response => response.data),
};

// Planning API
export const planningAPI = {
  getAll: (
    skip: number = 0,
    limit: number = 100,
    start_date?: string,
    end_date?: string,
    atelier_id?: number,
    responsable_id?: number,
    status?: string
  ): Promise<PlanningListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (atelier_id) params.append('atelier_id', atelier_id.toString());
    if (responsable_id) params.append('responsable_id', responsable_id.toString());
    if (status) params.append('status', status);
    return api.get(`/api/planning?${params.toString()}`).then(response => response.data);
  },

  getWeek: (week_date?: string): Promise<WeekPlanningResponse> => {
    const params = new URLSearchParams();
    if (week_date) params.append('week_date', week_date);
    return api.get(`/api/planning/week?${params.toString()}`).then(response => response.data);
  },

  getById: (id: number): Promise<PlanningEntry> =>
    api.get(`/api/planning/${id}`).then(response => response.data),

  getDeleted: (): Promise<PlanningListResponse> =>
    api.get('/api/planning/deleted').then(response => response.data),

  checkMachineConflict: (params: {
    machine_id: number;
    date: string;
    start_time: string;
    end_time: string;
    exclude_planning_id?: number;
  }): Promise<MachineConflictResponse> => {
    const search = new URLSearchParams();
    search.append('machine_id', params.machine_id.toString());
    search.append('date', params.date);
    search.append('start_time', params.start_time);
    search.append('end_time', params.end_time);
    if (params.exclude_planning_id !== undefined) {
      search.append('exclude_planning_id', params.exclude_planning_id.toString());
    }
    return api
      .get(`/api/planning/check-machine-conflict?${search.toString()}`)
      .then(response => response.data);
  },

  create: (data: PlanningCreate, force: boolean = false): Promise<PlanningEntry> => {
    const qs = force ? '?force=true' : '';
    return api.post(`/api/planning${qs}`, data).then(response => response.data);
  },

  update: (id: number, data: PlanningUpdate, force: boolean = false): Promise<PlanningEntry> => {
    const qs = force ? '?force=true' : '';
    return api.put(`/api/planning/${id}${qs}`, data).then(response => response.data);
  },

  delete: (id: number): Promise<void> =>
    api.delete(`/api/planning/${id}`).then(response => response.data),

  restore: (id: number): Promise<void> =>
    api.post(`/api/planning/${id}/restore`).then(response => response.data),

  updateStatus: (id: number, status: 'en_cours' | 'termine' | 'bloque'): Promise<PlanningEntry> =>
    api.put(`/api/planning/${id}/status?status=${status}`).then(response => response.data),
};

// Suivi (Project/Service Tracking) API
export const suiviAPI = {
  // Phases
  getPhases: (skip = 0, limit = 100): Promise<SuiviPhaseListResponse> =>
    api.get(`/api/suivi/phases?skip=${skip}&limit=${limit}`).then(response => response.data),

  createPhase: (data: SuiviPhaseCreate): Promise<SuiviPhase> =>
    api.post('/api/suivi/phases', data).then(response => response.data),

  updatePhase: (id: number, data: SuiviPhaseUpdate): Promise<SuiviPhase> =>
    api.put(`/api/suivi/phases/${id}`, data).then(response => response.data),

  deletePhase: (id: number): Promise<void> =>
    api.delete(`/api/suivi/phases/${id}`).then(response => response.data),

  // Steps
  getSteps: (phase_id?: number, skip = 0, limit = 100): Promise<SuiviPhaseStepListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (phase_id) params.append('phase_id', phase_id.toString());
    return api.get(`/api/suivi/steps?${params.toString()}`).then(response => response.data);
  },

  createStep: (data: SuiviPhaseStepCreate): Promise<SuiviPhaseStep> =>
    api.post('/api/suivi/steps', data).then(response => response.data),

  updateStep: (id: number, data: SuiviPhaseStepUpdate): Promise<SuiviPhaseStep> =>
    api.put(`/api/suivi/steps/${id}`, data).then(response => response.data),

  deleteStep: (id: number): Promise<void> =>
    api.delete(`/api/suivi/steps/${id}`).then(response => response.data),

  // Progress
  toggleProgress: (step_id: number, projet_id?: number, service_id?: number): Promise<ToggleProgressResponse> => {
    const params = new URLSearchParams();
    params.append('step_id', step_id.toString());
    if (projet_id) params.append('projet_id', projet_id.toString());
    if (service_id) params.append('service_id', service_id.toString());
    return api.post(`/api/suivi/progress/toggle?${params.toString()}`).then(response => response.data);
  },

  updateProgressNotes: (progress_id: number, notes: string): Promise<void> =>
    api.put(`/api/suivi/progress/${progress_id}/notes?notes=${encodeURIComponent(notes)}`).then(response => response.data),

  // Tracking
  getTracking: (
    type_filter?: string,
    status_filter?: string,
    search?: string,
    skip = 0,
    limit = 50
  ): Promise<ProjetServiceSuiviListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (type_filter) params.append('type_filter', type_filter);
    if (status_filter) params.append('status_filter', status_filter);
    if (search) params.append('search', search);
    return api.get(`/api/suivi/tracking?${params.toString()}`).then(response => response.data);
  },

  getTrackingDetail: (type: 'projet' | 'service', id: number): Promise<ProjetServiceSuivi> =>
    api.get(`/api/suivi/tracking/${type}/${id}`).then(response => response.data),

  // Initialize default phases
  initDefaultPhases: (): Promise<{ message: string }> =>
    api.post('/api/suivi/init-default-phases').then(response => response.data),

  // Mon Suivi (Worker View)
  /** The plans techniques that reach this planning entry (by its machine). */
  monSuiviPlans: (entryId: number): Promise<ProjetDessin[]> =>
    api.get(`/api/suivi/mon-suivi/${entryId}/plans`).then(r => r.data),
  getMonSuivi: (
    status_filter?: string,
    date_from?: string,
    date_to?: string,
    skip = 0,
    limit = 50
  ): Promise<MonSuiviListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (status_filter) params.append('status_filter', status_filter);
    if (date_from) params.append('date_from', date_from);
    if (date_to) params.append('date_to', date_to);
    return api.get(`/api/suivi/mon-suivi?${params.toString()}`).then(response => response.data);
  },
};

// ============== Chat API ==============
export const chatAPI = {
  // Conversations
  getConversations: (skip = 0, limit = 50): Promise<ConversationList> =>
    api.get(`/api/chat/conversations?skip=${skip}&limit=${limit}`).then(r => r.data),

  getConversation: (id: number): Promise<Conversation> =>
    api.get(`/api/chat/conversations/${id}`).then(r => r.data),

  createConversation: (data: ConversationCreate): Promise<Conversation> =>
    api.post('/api/chat/conversations', data).then(r => r.data),

  // Group Conversations
  createGroupConversation: (data: { group_name: string; participant_ids: number[] }): Promise<Conversation> =>
    api.post('/api/chat/groups', data).then(r => r.data),

  updateGroupConversation: (conversationId: number, data: { group_name?: string; group_avatar_url?: string }): Promise<Conversation> =>
    api.put(`/api/chat/groups/${conversationId}`, data).then(r => r.data),

  addGroupMembers: (conversationId: number, userIds: number[]): Promise<Conversation> =>
    api.post(`/api/chat/groups/${conversationId}/members`, { user_ids: userIds }).then(r => r.data),

  removeGroupMember: (conversationId: number, userId: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/api/chat/groups/${conversationId}/members/${userId}`).then(r => r.data),

  toggleGroupAdmin: (conversationId: number, userId: number): Promise<{ success: boolean; is_admin: boolean }> =>
    api.put(`/api/chat/groups/${conversationId}/members/${userId}/admin`).then(r => r.data),

  // Conversation Actions (Star/Archive)
  toggleStar: (conversationId: number): Promise<{ success: boolean; is_starred: boolean }> =>
    api.put(`/api/chat/conversations/${conversationId}/star`).then(r => r.data),

  toggleArchive: (conversationId: number): Promise<{ success: boolean; is_archived: boolean }> =>
    api.put(`/api/chat/conversations/${conversationId}/archive`).then(r => r.data),

  deleteConversation: (conversationId: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/api/chat/conversations/${conversationId}`).then(r => r.data),

  restoreConversation: (conversationId: number): Promise<{ success: boolean; message: string }> =>
    api.post(`/api/chat/conversations/${conversationId}/restore`).then(r => r.data),

  getDeletedConversations: (skip = 0, limit = 50): Promise<ConversationList> =>
    api.get(`/api/chat/conversations/deleted?skip=${skip}&limit=${limit}`).then(r => r.data),

  // Messages
  getMessages: (conversationId: number, skip = 0, limit = 50, beforeId?: number): Promise<MessageList> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (beforeId) params.append('before_id', beforeId.toString());
    return api.get(`/api/chat/conversations/${conversationId}/messages?${params.toString()}`).then(r => r.data);
  },

  sendMessage: (
    conversationId: number,
    content?: string,
    messageType = 'text',
    attachmentIds?: number[]
  ): Promise<ChatMessage> => {
    const params = new URLSearchParams();
    if (content) params.append('content', content);
    params.append('message_type', messageType);
    if (attachmentIds && attachmentIds.length > 0) {
      attachmentIds.forEach(id => params.append('attachment_ids', id.toString()));
    }
    return api.post(`/api/chat/conversations/${conversationId}/messages?${params.toString()}`).then(r => r.data);
  },

  markMessageRead: (messageId: number): Promise<{ success: boolean }> =>
    api.put(`/api/chat/messages/${messageId}/read`).then(r => r.data),

  deleteMessage: (messageId: number): Promise<{ success: boolean }> =>
    api.delete(`/api/chat/messages/${messageId}`).then(r => r.data),

  // Message search
  searchMessages: (query: string, skip = 0, limit = 50): Promise<MessageSearchResponse> =>
    api.get(`/api/chat/messages/search?q=${encodeURIComponent(query)}&skip=${skip}&limit=${limit}`).then(r => r.data),

  // File upload
  uploadFile: (file: File): Promise<FileUploadResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/chat/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data);
  },

  // Users
  getChatUsers: (search?: string): Promise<ChatUser[]> => {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/api/chat/users${params}`).then(r => r.data);
  },

  // Unread count
  getUnreadCount: (): Promise<UnreadCountResponse> =>
    api.get('/api/chat/unread-count').then(r => r.data),

  // Presence / Heartbeat
  sendHeartbeat: (): Promise<{ success: boolean; is_online: boolean }> =>
    api.post('/api/chat/presence/heartbeat').then(r => r.data),

  setOffline: (): Promise<{ success: boolean; is_online: boolean }> =>
    api.post('/api/chat/presence/offline').then(r => r.data),

  // WebSocket token
  getWsToken: (): Promise<{ token: string }> =>
    api.get('/api/chat/ws-token').then(r => r.data),
};

// ==================== Employee API (HR Module) ====================
export const employeesAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    statut?: string;
    type_contrat?: string;
  } & Record<string, any>): Promise<EmployeeListResponse> => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => searchParams.append(k, String(x))); return; }
        searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/employees?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<Employee> =>
    api.get(`/api/employees/${id}`).then(r => r.data),

  create: (data: EmployeeCreate): Promise<Employee> =>
    api.post('/api/employees', data).then(r => r.data),

  update: (id: number, data: EmployeeUpdate): Promise<Employee> =>
    api.put(`/api/employees/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/employees/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/employees/${id}/restore`).then(r => r.data),

  getDeleted: (): Promise<EmployeeListResponse> =>
    api.get('/api/employees/deleted').then(r => r.data),

  getStats: (): Promise<EmployeeStats> =>
    api.get('/api/employees/stats').then(r => r.data),

  getNextMatricule: (typeContrat?: string): Promise<{ matricule: string }> => {
    const params = typeContrat ? `?type_contrat=${typeContrat}` : '';
    return api.get(`/api/employees/next-matricule${params}`).then(r => r.data);
  },

  getAllForDropdown: (): Promise<EmployeeDropdownItem[]> =>
    api.get('/api/employees/all').then(r => r.data),

  uploadPhoto: (employeeId: number, file: File): Promise<{ message: string; photo_url: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/api/employees/${employeeId}/upload-photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data);
  },

  deletePhoto: (employeeId: number): Promise<{ message: string }> =>
    api.delete(`/api/employees/${employeeId}/photo`).then(r => r.data),

  // Document management
  getDocuments: (employeeId: number): Promise<EmployeeDocumentListResponse> =>
    api.get(`/api/employees/${employeeId}/documents`).then(r => r.data),

  uploadDocument: (
    employeeId: number,
    file: File,
    documentType: DocumentType,
    title: string,
    description?: string
  ): Promise<EmployeeDocument> => {
    const formData = new FormData();
    formData.append('file', file);
    const params = new URLSearchParams();
    params.append('document_type', documentType);
    params.append('title', title);
    if (description) params.append('description', description);
    return api.post(`/api/employees/${employeeId}/documents?${params.toString()}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data);
  },

  deleteDocument: (employeeId: number, documentId: number): Promise<{ message: string }> =>
    api.delete(`/api/employees/${employeeId}/documents/${documentId}`).then(r => r.data),
};

// ==================== STC (Solde de Tout Compte) API (HR Module) ====================
export const stcAPI = {
  // employeeStatut keeps the count in step with a list built from the same
  // statut — without it the KPI counts settlements of employees since set back
  // to ACTIF, which the STC table (INACTIF only) never renders.
  getAll: (employeeStatut?: string): Promise<STCListResponse> =>
    api.get('/api/stc', {
      params: employeeStatut ? { employee_statut: employeeStatut } : undefined,
    }).then(r => r.data),

  getByEmployee: (employeeId: number): Promise<STC> =>
    api.get(`/api/stc/employee/${employeeId}`).then(r => r.data),

  // Pointage-based proration + the employee's primes, for a NEW STC only.
  // dateSortie (YYYY-MM-DD) overrides the stored exit date to recompute the period.
  getPrefill: (employeeId: number, dateSortie?: string): Promise<STCPrefill> =>
    api.get(`/api/stc/employee/${employeeId}/prefill`, {
      params: dateSortie ? { date_sortie: dateSortie } : undefined,
    }).then(r => r.data),

  create: (data: STCCreate): Promise<STC> =>
    api.post('/api/stc', data).then(r => r.data),

  update: (id: number, data: STCUpdate): Promise<STC> =>
    api.put(`/api/stc/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/stc/${id}`).then(r => r.data),

  // Reçu pour Solde de Tout Compte PDF (from the saved record) — blob for preview.
  getPDFBlob: async (id: number): Promise<Blob> => {
    const response = await api.get(`/api/stc/${id}/pdf`, { responseType: 'blob' });
    return new Blob([response.data], { type: 'application/pdf' });
  },
};

// ==================== Pointage API (HR Module) ====================
export const pointageAPI = {
  getMonthly: (month: number, year: number): Promise<MonthlyPointageResponse> =>
    api.get(`/api/pointage/monthly?month=${month}&year=${year}`).then(r => r.data),

  getStats: (month: number, year: number): Promise<PointageStats> =>
    api.get(`/api/pointage/stats?month=${month}&year=${year}`).then(r => r.data),

  getDaySummary: (date: string): Promise<PointageDaySummary> =>
    api.get(`/api/pointage/day-summary?target_date=${date}`).then(r => r.data),

  create: (data: PointageEntryCreate): Promise<PointageEntry> =>
    api.post('/api/pointage', data).then(r => r.data),

  update: (id: number, data: PointageEntryUpdate): Promise<PointageEntry> =>
    api.put(`/api/pointage/${id}`, data).then(r => r.data),

  toggle: (data: PointageBulkUpdate): Promise<PointageEntry> =>
    api.post('/api/pointage/toggle', data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/pointage/${id}`).then(r => r.data),

  initMonth: (month: number, year: number): Promise<{ message: string; entries_created: number }> =>
    api.post(`/api/pointage/init-month?month=${month}&year=${year}`).then(r => r.data),

  // Save a manual "Statut Pointage" pick (persisted draft; not written to the
  // pointage grid until validation). Upsert by (employee_id, date).
  setPointageDraft: (payload: { employee_id: number; date: string; status: string }): Promise<{ ok: boolean }> =>
    api.put('/api/attendance/pointage-draft', payload).then(r => r.data),

  // Bulk-fill the Pointage du Personnel from biometric presence over a date
  // range; the saved drafts are applied on top server-side.
  // dry_run=true returns the counts without writing (for the confirmation popup).
  fillFromBiometric: (payload: {
    start_date: string;
    end_date: string;
    dry_run?: boolean;
  }): Promise<{
    message: string;
    dry_run: boolean;
    filled_present: number;
    filled_retard: number;
    filled_absent: number;
    filled_ferie: number;
    overridden: number;
    skipped_protected: number;
    employees: number;
    employees_without_pin: number;
    days: number;
  }> =>
    api.post('/api/pointage/fill-from-biometric', payload).then(r => r.data),
};

// ==================== Conge API (HR Module) ====================
export const congesAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    employee_id?: number;
    type_conge?: string;
    statut?: string;
    annee?: number;
  } & Record<string, any>): Promise<CongeListResponse> => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => searchParams.append(k, String(x))); return; }
        searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/conges?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<Conge> =>
    api.get(`/api/conges/${id}`).then(r => r.data),

  create: (data: CongeCreate): Promise<Conge> =>
    api.post('/api/conges', data).then(r => r.data),

  update: (id: number, data: CongeUpdate): Promise<Conge> =>
    api.put(`/api/conges/${id}`, data).then(r => r.data),

  validate: (id: number, data: CongeValidate): Promise<Conge> =>
    api.put(`/api/conges/${id}/validate`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/conges/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/conges/${id}/restore`).then(r => r.data),

  getDeleted: (): Promise<CongeListResponse> =>
    api.get('/api/conges/deleted').then(r => r.data),

  getEmployeeSolde: (employeeId: number, annee?: number): Promise<EmployeeSoldeResponse> => {
    const params = annee ? `?annee=${annee}` : '';
    return api.get(`/api/conges/solde/employee/${employeeId}${params}`).then(r => r.data);
  },

  getRecapitulatif: (annee: number): Promise<RecapitulatifCongeResponse> =>
    api.get(`/api/conges/recapitulatif?annee=${annee}`).then(r => r.data),
};

// ==================== Jours Fériés API (HR Module) ====================
export const joursFeriesAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    annee?: number;
    type_jour?: string;
    extra?: Record<string, any>;
  }): Promise<JourFerieListResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.size) searchParams.append('size', params.size.toString());
    if (params?.annee) searchParams.append('annee', params.annee.toString());
    if (params?.type_jour) searchParams.append('type_jour', params.type_jour);
    if (params?.extra) {
      Object.entries(params.extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/jours-feries?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<JourFerie> =>
    api.get(`/api/jours-feries/${id}`).then(r => r.data),

  create: (data: JourFerieCreate): Promise<JourFerie> =>
    api.post('/api/jours-feries', data).then(r => r.data),

  createBulk: (data: JourFerieCreate[]): Promise<{ message: string; created: string[]; skipped: string[] }> =>
    api.post('/api/jours-feries/bulk', data).then(r => r.data),

  update: (id: number, data: JourFerieUpdate): Promise<JourFerie> =>
    api.put(`/api/jours-feries/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/jours-feries/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/jours-feries/${id}/restore`).then(r => r.data),

  getDeleted: (): Promise<JourFerieListResponse> =>
    api.get('/api/jours-feries/deleted').then(r => r.data),

  getDates: (annee?: number): Promise<string[]> => {
    const params = annee ? `?annee=${annee}` : '';
    return api.get(`/api/jours-feries/dates${params}`).then(r => r.data);
  },

  getBetween: (dateDebut: string, dateFin: string): Promise<JourFerie[]> =>
    api.get(`/api/jours-feries/between?date_debut=${dateDebut}&date_fin=${dateFin}`).then(r => r.data),

  getYears: (): Promise<number[]> =>
    api.get('/api/jours-feries/years').then(r => r.data),
};

// ==================== Attestations Travail API (HR Module) ====================
export const attestationsTravailAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    employee_id?: number;
    annee?: number;
    extra?: Record<string, any>;
  }): Promise<AttestationTravailListResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.size) searchParams.append('size', params.size.toString());
    if (params?.search) searchParams.append('search', params.search);
    if (params?.employee_id) searchParams.append('employee_id', params.employee_id.toString());
    if (params?.annee) searchParams.append('annee', params.annee.toString());
    if (params?.extra) {
      Object.entries(params.extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/attestations-travail?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<AttestationTravail> =>
    api.get(`/api/attestations-travail/${id}`).then(r => r.data),

  create: (data: AttestationTravailCreate): Promise<AttestationTravail> =>
    api.post('/api/attestations-travail', data).then(r => r.data),

  update: (id: number, data: AttestationTravailUpdate): Promise<AttestationTravail> =>
    api.put(`/api/attestations-travail/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/attestations-travail/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/attestations-travail/${id}/restore`).then(r => r.data),

  getDeleted: (): Promise<AttestationTravailListResponse> =>
    api.get('/api/attestations-travail/deleted').then(r => r.data),
};

// ==================== Attestations Salaire API (HR Module) ====================
export const attestationsSalaireAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    employee_id?: number;
    annee?: number;
    extra?: Record<string, any>;
  }): Promise<AttestationSalaireListResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.size) searchParams.append('size', params.size.toString());
    if (params?.search) searchParams.append('search', params.search);
    if (params?.employee_id) searchParams.append('employee_id', params.employee_id.toString());
    if (params?.annee) searchParams.append('annee', params.annee.toString());
    if (params?.extra) {
      Object.entries(params.extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/attestations-salaire?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<AttestationSalaire> =>
    api.get(`/api/attestations-salaire/${id}`).then(r => r.data),

  create: (data: AttestationSalaireCreate): Promise<AttestationSalaire> =>
    api.post('/api/attestations-salaire', data).then(r => r.data),

  update: (id: number, data: AttestationSalaireUpdate): Promise<AttestationSalaire> =>
    api.put(`/api/attestations-salaire/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/attestations-salaire/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/attestations-salaire/${id}/restore`).then(r => r.data),

  getDeleted: (): Promise<AttestationSalaireListResponse> =>
    api.get('/api/attestations-salaire/deleted').then(r => r.data),
};

// ==================== Prets API (HR Module) ====================
export const pretsAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    statut?: string;
    employee_id?: number;
  } & Record<string, any>): Promise<PretListResponse> => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => searchParams.append(k, String(x))); return; }
        searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/prets?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<Pret> =>
    api.get(`/api/prets/${id}`).then(r => r.data),

  getStats: (): Promise<PretStats> =>
    api.get('/api/prets/stats').then(r => r.data),

  getEmployeeHistory: (employeeId: number): Promise<Pret[]> =>
    api.get(`/api/prets/employee/${employeeId}/history`).then(r => r.data),

  create: (data: PretCreate): Promise<Pret> =>
    api.post('/api/prets', data).then(r => r.data),

  update: (id: number, data: PretUpdate): Promise<Pret> =>
    api.put(`/api/prets/${id}`, data).then(r => r.data),

  validate: (id: number, data: PretValidate): Promise<Pret> =>
    api.put(`/api/prets/${id}/validate`, data).then(r => r.data),

  addPayment: (id: number, data: PretAddPayment): Promise<Pret> =>
    api.post(`/api/prets/${id}/payment`, data).then(r => r.data),

  togglePrelevement: (id: number, data: { mois: number; annee: number; inclus: boolean }): Promise<Pret> =>
    api.put(`/api/prets/${id}/toggle-prelevement`, data).then(r => r.data),

  getHistorique: (id: number): Promise<PretHistoriqueResponse> =>
    api.get(`/api/prets/${id}/historique`).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/prets/${id}`).then(r => r.data),

  generateArabicPDF: async (id: number): Promise<void> => {
    const response = await api.get(`/api/prets/${id}/generate-arabic-pdf`, {
      responseType: 'blob',
    });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = response.headers['content-disposition']
      ?.split('filename=')[1]
      ?.replace(/"/g, '') || `pret_${id}_ar.pdf`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },

  generateFrenchPDF: async (id: number): Promise<void> => {
    const response = await api.get(`/api/prets/${id}/generate-french-pdf`, {
      responseType: 'blob',
    });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = response.headers['content-disposition']
      ?.split('filename=')[1]
      ?.replace(/"/g, '') || `pret_${id}_fr.pdf`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },

  // Blob variants for the in-app PDF preview (print/download from the viewer).
  getArabicPDFBlob: async (id: number): Promise<Blob> => {
    const response = await api.get(`/api/prets/${id}/generate-arabic-pdf`, { responseType: 'blob' });
    return new Blob([response.data], { type: 'application/pdf' });
  },

  getFrenchPDFBlob: async (id: number): Promise<Blob> => {
    const response = await api.get(`/api/prets/${id}/generate-french-pdf`, { responseType: 'blob' });
    return new Blob([response.data], { type: 'application/pdf' });
  },
};

// Acomptes (Salary Advance) API
export const acomptesAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    statut?: string;
    employee_id?: number;
  } & Record<string, any>): Promise<AcompteListResponse> => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => searchParams.append(k, String(x))); return; }
        searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/acomptes?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<Acompte> =>
    api.get(`/api/acomptes/${id}`).then(r => r.data),

  getStats: (): Promise<AcompteStats> =>
    api.get('/api/acomptes/stats').then(r => r.data),

  getEtatVirement: (mois: number, annee: number): Promise<{
    mois: number;
    annee: number;
    items: { matricule: string; rib: string; nom_complet: string; montant: number }[];
    total_montant: number;
  }> =>
    api.get(`/api/acomptes/etat-virement?mois=${mois}&annee=${annee}`).then(r => r.data),

  create: (data: AcompteCreate): Promise<Acompte> =>
    api.post('/api/acomptes', data).then(r => r.data),

  update: (id: number, data: AcompteUpdate): Promise<Acompte> =>
    api.put(`/api/acomptes/${id}`, data).then(r => r.data),

  validate: (id: number, data: AcompteValidate): Promise<Acompte> =>
    api.put(`/api/acomptes/${id}/validate`, data).then(r => r.data),

  markPaid: (id: number, data?: AcompteMarkPaid): Promise<Acompte> =>
    api.put(`/api/acomptes/${id}/mark-paid`, data || {}).then(r => r.data),

  togglePrelevement: (id: number, data: { mois: number; annee: number; inclus: boolean }): Promise<Acompte> =>
    api.put(`/api/acomptes/${id}/toggle-prelevement`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/acomptes/${id}`).then(r => r.data),

  generatePDF: async (id: number): Promise<void> => {
    const response = await api.get(`/api/acomptes/${id}/generate-pdf`, {
      responseType: 'blob',
    });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = response.headers['content-disposition']
      ?.split('filename=')[1]
      ?.replace(/"/g, '') || `acompte_${id}.pdf`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};

// Autorisations Absence (Absence Authorization) API
export const autorisationsAbsenceAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    statut?: string;
    employee_id?: number;
  } & Record<string, any>): Promise<AutorisationAbsenceListResponse> => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => searchParams.append(k, String(x))); return; }
        searchParams.append(k, String(v));
      });
    }
    return api.get(`/api/autorisations-absence?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<AutorisationAbsence> =>
    api.get(`/api/autorisations-absence/${id}`).then(r => r.data),

  getStats: (): Promise<AutorisationAbsenceStats> =>
    api.get('/api/autorisations-absence/stats').then(r => r.data),

  getEmployeeHistory: (employeeId: number): Promise<AutorisationAbsence[]> =>
    api.get(`/api/autorisations-absence/employee/${employeeId}/history`).then(r => r.data),

  create: (data: AutorisationAbsenceCreate): Promise<AutorisationAbsence> =>
    api.post('/api/autorisations-absence', data).then(r => r.data),

  update: (id: number, data: AutorisationAbsenceUpdate): Promise<AutorisationAbsence> =>
    api.put(`/api/autorisations-absence/${id}`, data).then(r => r.data),

  validate: (id: number, data: AutorisationAbsenceValidate): Promise<AutorisationAbsence> =>
    api.put(`/api/autorisations-absence/${id}/validate`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/autorisations-absence/${id}`).then(r => r.data),
};

// Paie (Payroll) API
export interface PretPaiementInfo {
  pret_id: number;
  ref_pret: string | null;
  montant_mensuel: number;
  paiement_id: number | null;
  montant_paye: number | null;
  date_paiement: string | null;
  is_paid: boolean;
  mois_restants: number | null;
  inclus_dans_calcul: boolean;
}

export interface AcompteInfo {
  acompte_id: number;
  ref_acompte: string | null;
  montant: number;
  date_demande: string;
  date_paiement: string | null;
  is_paid: boolean;
  inclus_dans_calcul: boolean;
}

export interface PointageSummary {
  heures_absence: number;
  jours_absent: number;
  jours_ferie: number;
  jours_conge_paye: number;
  jours_conge_maladie: number;
  jours_conge_mariage: number;
  jours_conge_deces: number;
  jours_conge_naissance: number;
  heures_presence: number;
  jours_present: number;
  heures_supplementaires: number;
}

export interface AncienneteInfo {
  annees: number;
  mois: number;
  taux_anciennete: number;
}

export interface PayrollMonthResponse {
  employee_id: number;
  year: number;
  month: number;
  pret: PretPaiementInfo | null;
  acomptes: AcompteInfo[] | null;
  pointage_summary: PointageSummary | null;
  anciennete: AncienneteInfo | null;
}

export const paieAPI = {
  getPayrollMonth: (employeeId: number, year: number, month: number): Promise<PayrollMonthResponse> =>
    api.get(`/api/paie/employees/${employeeId}/payroll-month?year=${year}&month=${month}`).then(r => r.data),
};

// Bulletins de Paie API
export const bulletinsPaieAPI = {
  getAll: (params?: {
    page?: number;
    size?: number;
    search?: string;
    statut?: string;
    employee_id?: number;
    mois?: number;
    annee?: number;
  }): Promise<BulletinPaieListResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.size) searchParams.append('size', params.size.toString());
    if (params?.search) searchParams.append('search', params.search);
    if (params?.statut) searchParams.append('statut', params.statut);
    if (params?.employee_id) searchParams.append('employee_id', params.employee_id.toString());
    if (params?.mois) searchParams.append('mois', params.mois.toString());
    if (params?.annee) searchParams.append('annee', params.annee.toString());
    return api.get(`/api/bulletins-paie?${searchParams.toString()}`).then(r => r.data);
  },

  getById: (id: number): Promise<BulletinPaie> =>
    api.get(`/api/bulletins-paie/${id}`).then(r => r.data),

  getByEmployeeMonth: (employeeId: number, mois: number, annee: number): Promise<BulletinPaie | null> =>
    api.get(`/api/bulletins-paie/employee/${employeeId}/month/${mois}/year/${annee}`).then(r => r.data),

  getStats: (mois: number, annee: number): Promise<BulletinPaieStats> =>
    api.get(`/api/bulletins-paie/stats?mois=${mois}&annee=${annee}`).then(r => r.data),

  // Which bulletins of the month no longer match a fresh calculation.
  getDrift: (mois: number, annee: number): Promise<BulletinDriftResponse> =>
    api.get(`/api/bulletins-paie/drift?mois=${mois}&annee=${annee}`).then(r => r.data),

  getEmployeeHistory: (employeeId: number): Promise<BulletinPaie[]> =>
    api.get(`/api/bulletins-paie/employee/${employeeId}/history`).then(r => r.data),

  generate: (data: BulletinPaieCreate): Promise<BulletinPaie> =>
    api.post('/api/bulletins-paie', data).then(r => r.data),

  generateFromCalcul: (data: BulletinPaieCreateFromCalcul): Promise<BulletinPaie> =>
    api.post('/api/bulletins-paie/generate-from-calcul', data).then(r => r.data),

  update: (id: number, data: BulletinPaieUpdate): Promise<BulletinPaie> =>
    api.put(`/api/bulletins-paie/${id}`, data).then(r => r.data),

  validate: (id: number, data: BulletinPaieValidate): Promise<BulletinPaie> =>
    api.put(`/api/bulletins-paie/${id}/validate`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/bulletins-paie/${id}`).then(r => r.data),

  generateAll: (mois: number, annee: number): Promise<GenerateAllBulletinsResponse> =>
    api.post('/api/bulletins-paie/generate-all', { mois, annee }).then(r => r.data),

  getMonthStatus: (mois: number, annee: number): Promise<Record<string, BulletinPaie>> =>
    api.get(`/api/bulletins-paie/month-status?mois=${mois}&annee=${annee}`).then(r => r.data),

  deleteMonth: (mois: number, annee: number): Promise<{ deleted: number; acomptes_reverted: number; pret_payments_reverted: number }> =>
    api.delete('/api/bulletins-paie/month', { params: { mois, annee } }).then(r => r.data),

  preCheck: (mois: number, annee: number): Promise<{
    total_employees: number;
    ready: number;
    not_ready: number;
    already_exists: number;
    details: Array<{
      employee_id: number;
      employee_name: string;
      matricule: string;
      status: 'ready' | 'error' | 'exists';
      reason?: string;
    }>;
  }> => api.get('/api/bulletins-paie/pre-check', { params: { mois, annee } }).then(r => r.data),
};

// HR Dashboard API
export interface HRDashboardStats {
  effectif: {
    total: number;
    actifs: number;
    inactifs: number;
    nouveaux_ce_mois: number;
  };
  presence: {
    presents_aujourdhui: number;
    absents_aujourdhui: number;
    en_conge_aujourdhui: number;
    taux_presence_mois: number;
  };
  conges: {
    demandes_en_attente: number;
    employes_en_conge: number;
    jours_pris_ce_mois: number;
  };
  prets: {
    demandes_en_attente: number;
    prets_en_cours: number;
    montant_restant: number;
    prelevements_mensuels: number;
  };
}

export const hrDashboardAPI = {
  getStats: (): Promise<HRDashboardStats> =>
    api.get('/api/hr-dashboard/stats').then(response => response.data),
};

// Commercial Dashboard API
export interface CommercialDashboardStats {
  devis: {
    total: number;
    en_cours: number;
    valide: number;
    annule: number;
    montant_total: number;
  };
  bons_livraison: {
    total: number;
    en_cours: number;
    livre: number;
    annule: number;
  };
}

export const commercialDashboardAPI = {
  getStats: (): Promise<CommercialDashboardStats> =>
    api.get('/api/commercial-dashboard/stats').then(response => response.data),
};

// Financier Dashboard API
export interface FinancierDashboardStats {
  encaissements: {
    total: number;
    paiement_facture: number;
    avance_devis: number;
    montant_total: number;
  };
}

export const financierDashboardAPI = {
  getStats: (): Promise<FinancierDashboardStats> =>
    api.get('/api/financier-dashboard/stats').then(response => response.data),
};

// Production Dashboard API
export interface ProductionDashboardStats {
  projets: {
    total: number;
    active: number;
    inactive: number;
  };
  services: {
    total: number;
    active: number;
    inactive: number;
  };
}

export const productionDashboardAPI = {
  getStats: (): Promise<ProductionDashboardStats> =>
    api.get('/api/production-dashboard/stats').then(response => response.data),
};

// SMTP Settings API
export const smtpSettingsAPI = {
  getAll: (): Promise<SmtpSetting[]> =>
    api.get('/api/smtp-settings').then(response => response.data),

  getDeleted: (): Promise<SmtpSetting[]> =>
    api.get('/api/smtp-settings/deleted').then(response => response.data),

  getDefault: (): Promise<SmtpSetting> =>
    api.get('/api/smtp-settings/default').then(response => response.data),

  getById: (id: number): Promise<SmtpSetting> =>
    api.get(`/api/smtp-settings/${id}`).then(response => response.data),

  create: (data: SmtpSettingCreate): Promise<SmtpSetting> =>
    api.post('/api/smtp-settings', data).then(response => response.data),

  update: (id: number, data: SmtpSettingUpdate): Promise<SmtpSetting> =>
    api.put(`/api/smtp-settings/${id}`, data).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/smtp-settings/${id}`).then(response => response.data),

  restore: (id: number): Promise<void> =>
    api.post(`/api/smtp-settings/${id}/restore`).then(response => response.data),

  testConnection: (id: number): Promise<SmtpTestResponse> =>
    api.post(`/api/smtp-settings/${id}/test-connection`).then(response => response.data),

  sendTestEmail: (id: number, data: SmtpTestRequest): Promise<SmtpTestResponse> =>
    api.post(`/api/smtp-settings/${id}/send-test`, data).then(response => response.data),
};

// Email Events API
export const emailEventsAPI = {
  getAll: (): Promise<EmailEvent[]> =>
    api.get('/api/email-events').then(response => response.data),

  getByModule: (): Promise<EmailEventsByModule[]> =>
    api.get('/api/email-events/by-module').then(response => response.data),

  getModules: (): Promise<string[]> =>
    api.get('/api/email-events/modules').then(response => response.data),

  getById: (id: number): Promise<EmailEvent> =>
    api.get(`/api/email-events/${id}`).then(response => response.data),

  getByCode: (code: string): Promise<EmailEvent> =>
    api.get(`/api/email-events/code/${code}`).then(response => response.data),

  create: (data: EmailEventCreate): Promise<EmailEvent> =>
    api.post('/api/email-events', data).then(response => response.data),

  update: (id: number, data: EmailEventUpdate): Promise<EmailEvent> =>
    api.put(`/api/email-events/${id}`, data).then(response => response.data),

  toggle: (id: number, data: EmailEventToggle): Promise<EmailEvent> =>
    api.patch(`/api/email-events/${id}/toggle`, data).then(response => response.data),

  updateTemplate: (id: number, data: EmailEventTemplateUpdate): Promise<EmailEvent> =>
    api.patch(`/api/email-events/${id}/template`, data).then(response => response.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/api/email-events/${id}`).then(response => response.data),

  seed: (): Promise<{ message: string; created: number; skipped: number }> =>
    api.post('/api/email-events/seed').then(response => response.data),
};

// Email Queue API
export const emailQueueAPI = {
  getAll: (filters?: EmailQueueFilter & Record<string, any>): Promise<EmailQueueListResponse> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        if (Array.isArray(v)) { v.forEach(x => params.append(k, String(x))); return; }
        params.append(k, String(v));
      });
    }
    return api.get(`/api/email-queue?${params.toString()}`).then(response => response.data);
  },

  getStats: (): Promise<EmailQueueStats> =>
    api.get('/api/email-queue/stats').then(response => response.data),

  getModules: (): Promise<string[]> =>
    api.get('/api/email-queue/modules').then(response => response.data),

  getById: (id: number): Promise<EmailQueue> =>
    api.get(`/api/email-queue/${id}`).then(response => response.data),

  create: (data: EmailQueueManualSend): Promise<EmailQueue> =>
    api.post('/api/email-queue', data).then(response => response.data),

  retry: (id: number): Promise<EmailQueueRetryResponse> =>
    api.post(`/api/email-queue/${id}/retry`).then(response => response.data),

  cancel: (id: number): Promise<{ success: boolean; message: string }> =>
    api.post(`/api/email-queue/${id}/cancel`).then(response => response.data),

  sendNow: (id: number): Promise<{ success: boolean; message: string }> =>
    api.post(`/api/email-queue/${id}/send-now`).then(response => response.data),

  delete: (id: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/api/email-queue/${id}`).then(response => response.data),

  sendDirect: (data: {
    to_email: string;
    subject: string;
    body: string;
    to_name?: string;
    cc_emails?: string[];
    bcc_emails?: string[];
    smtp_setting_id?: number;
    attachments?: File[];
  }): Promise<{ success: boolean; message: string }> => {
    const formData = new FormData();
    formData.append('to_email', data.to_email);
    formData.append('subject', data.subject);
    formData.append('body', data.body);
    if (data.to_name) formData.append('to_name', data.to_name);
    if (data.cc_emails) formData.append('cc_emails', JSON.stringify(data.cc_emails));
    if (data.bcc_emails) formData.append('bcc_emails', JSON.stringify(data.bcc_emails));
    if (data.smtp_setting_id) formData.append('smtp_setting_id', String(data.smtp_setting_id));
    if (data.attachments) {
      data.attachments.forEach((file) => {
        formData.append('attachments', file);
      });
    }
    return api.post('/api/email-queue/send-direct', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(response => response.data);
  },
};

// ==================== PAIE (Payroll) API ====================

// Primes Exonerees (Tax-exempt bonuses) API
export const primesExonereesAPI = {
  getAll: (skip = 0, limit = 100, search?: string): Promise<PrimeExonereeListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    return api.get(`/api/primes-exonerees?${params.toString()}`).then(r => r.data);
  },

  getAllForDropdown: (): Promise<PrimeDropdownItem[]> =>
    api.get('/api/primes-exonerees/all-for-dropdown').then(r => r.data),

  getById: (id: number): Promise<PrimeExoneree> =>
    api.get(`/api/primes-exonerees/${id}`).then(r => r.data),

  getDeleted: (): Promise<PrimeExonereeListResponse> =>
    api.get('/api/primes-exonerees/deleted').then(r => r.data),

  create: (data: PrimeExonereeCreate): Promise<PrimeExoneree> =>
    api.post('/api/primes-exonerees', data).then(r => r.data),

  update: (id: number, data: PrimeExonereeUpdate): Promise<PrimeExoneree> =>
    api.put(`/api/primes-exonerees/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/primes-exonerees/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/primes-exonerees/${id}/restore`).then(r => r.data),
};

// Primes Non Exonerees (Taxable bonuses) API
export const primesNonExonereesAPI = {
  getAll: (skip = 0, limit = 100, search?: string): Promise<PrimeNonExonereeListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    return api.get(`/api/primes-non-exonerees?${params.toString()}`).then(r => r.data);
  },

  getAllForDropdown: (): Promise<PrimeDropdownItem[]> =>
    api.get('/api/primes-non-exonerees/all-for-dropdown').then(r => r.data),

  getById: (id: number): Promise<PrimeNonExoneree> =>
    api.get(`/api/primes-non-exonerees/${id}`).then(r => r.data),

  getDeleted: (): Promise<PrimeNonExonereeListResponse> =>
    api.get('/api/primes-non-exonerees/deleted').then(r => r.data),

  create: (data: PrimeNonExonereeCreate): Promise<PrimeNonExoneree> =>
    api.post('/api/primes-non-exonerees', data).then(r => r.data),

  update: (id: number, data: PrimeNonExonereeUpdate): Promise<PrimeNonExoneree> =>
    api.put(`/api/primes-non-exonerees/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/primes-non-exonerees/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/primes-non-exonerees/${id}/restore`).then(r => r.data),
};

// Cotisations Sociales (Social contributions) API
export const cotisationsSocialesAPI = {
  getAll: (skip = 0, limit = 100, search?: string): Promise<CotisationSocialeListResponse> => {
    const params = new URLSearchParams();
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    return api.get(`/api/cotisations-sociales?${params.toString()}`).then(r => r.data);
  },

  getAllForDropdown: (): Promise<CotisationDropdownItem[]> =>
    api.get('/api/cotisations-sociales/all-for-dropdown').then(r => r.data),

  getById: (id: number): Promise<CotisationSociale> =>
    api.get(`/api/cotisations-sociales/${id}`).then(r => r.data),

  getDeleted: (): Promise<CotisationSocialeListResponse> =>
    api.get('/api/cotisations-sociales/deleted').then(r => r.data),

  create: (data: CotisationSocialeCreate): Promise<CotisationSociale> =>
    api.post('/api/cotisations-sociales', data).then(r => r.data),

  update: (id: number, data: CotisationSocialeUpdate): Promise<CotisationSociale> =>
    api.put(`/api/cotisations-sociales/${id}`, data).then(r => r.data),

  delete: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/cotisations-sociales/${id}`).then(r => r.data),

  restore: (id: number): Promise<{ message: string }> =>
    api.post(`/api/cotisations-sociales/${id}/restore`).then(r => r.data),
};

// Employee Primes API
export const employeePrimesAPI = {
  get: (employeeId: number): Promise<EmployeePrimesResponse> =>
    api.get(`/api/employees/${employeeId}/primes`).then(r => r.data),

  getBulk: (employeeIds: number[]): Promise<Record<string, EmployeePrimesResponse>> =>
    api.post('/api/employees/bulk-primes', { employee_ids: employeeIds }).then(r => r.data),

  update: (employeeId: number, data: EmployeePrimesUpdate): Promise<EmployeePrimesResponse> =>
    api.put(`/api/employees/${employeeId}/primes`, data).then(r => r.data),
};

// Projet Dessins API (drawings/CAD archive per project)
export interface ProjetDessinsListFilters {
  search?: string;
  type?: DessinOwnerType | '';
  code?: string;
  nom?: string;
  client_name?: string;
  date_debut_from?: string;
  date_debut_to?: string;
  date_fin_from?: string;
  date_fin_to?: string;
  latest_upload_from?: string;
  latest_upload_to?: string;
  dessin_filter?: 'avec' | 'sans' | '';
  skip?: number;
  limit?: number;
}

export const projetDessinsAPI = {
  listProjetsWithCounts: (filters: ProjetDessinsListFilters = {}): Promise<ProjetWithDessinCountListResponse> => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        params.append(k, String(v));
      }
    });
    const qs = params.toString();
    return api.get(`/api/projet-dessins/projets${qs ? `?${qs}` : ''}`).then(r => r.data);
  },

  listFor: (type: DessinOwnerType, id: number): Promise<ProjetDessinListResponse> =>
    api.get(`/api/projet-dessins/${type}/${id}`).then(r => r.data),

  create: (
    type: DessinOwnerType,
    id: number,
    file: File | File[],  // several files = one plan with several files
    title: string,
    description?: string,
    note?: string,
    onProgress?: (percent: number) => void,
    plan?: PlanFields,
  ): Promise<ProjetDessin> => {
    const fd = new FormData();
    (Array.isArray(file) ? file : [file]).forEach((x) => fd.append('files', x));
    fd.append('title', title);
    if (description) fd.append('description', description);
    if (note) fd.append('note', note);
    Object.entries(plan || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') fd.append(k, String(v));
    });
    return api
      .post(`/api/projet-dessins/${type}/${id}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (ev) => {
          if (onProgress && ev.total) {
            onProgress(Math.round((ev.loaded * 100) / ev.total));
          }
        },
      })
      .then(r => r.data);
  },

  update: (dessinId: number, data: ProjetDessinUpdate): Promise<ProjetDessin> =>
    api.put(`/api/projet-dessins/${dessinId}`, data).then(r => r.data),

  delete: (dessinId: number): Promise<{ message: string }> =>
    api.delete(`/api/projet-dessins/${dessinId}`).then(r => r.data),

  uploadVersion: (
    dessinId: number,
    file: File | File[],
    note?: string,
    onProgress?: (percent: number) => void,
  ): Promise<ProjetDessinVersion> => {
    const fd = new FormData();
    (Array.isArray(file) ? file : [file]).forEach((x) => fd.append('files', x));
    if (note) fd.append('note', note);
    return api
      .post(`/api/projet-dessins/${dessinId}/versions`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (ev) => {
          if (onProgress && ev.total) {
            onProgress(Math.round((ev.loaded * 100) / ev.total));
          }
        },
      })
      .then(r => r.data);
  },

  deleteVersion: (dessinId: number, versionId: number): Promise<{ message: string }> =>
    api.delete(`/api/projet-dessins/${dessinId}/versions/${versionId}`).then(r => r.data),

  // Fetch a version's file through the authenticated proxy as a Blob (the
  // endpoint requires the auth cookie, so we cannot hand the URL straight to the
  // PDF.js worker — we load it here and feed the viewer a Blob URL instead).
  getVersionFileBlob: (versionId: number): Promise<Blob> =>
    api
      .get(`/api/projet-dessins/versions/${versionId}/file`, { responseType: 'blob' })
      .then(r => r.data),

  // Plans techniques
  plans: (params: { groupe?: string; machine_id?: number | ''; q?: string; skip?: number; limit?: number }): Promise<PlansListResponse> =>
    api.get('/api/projet-dessins/plans', {
      params: { ...params, groupe: params.groupe || undefined, machine_id: params.machine_id || undefined, q: params.q || undefined },
    }).then(r => r.data),
  formMeta: (type: DessinOwnerType, id: number): Promise<PlanFormMeta> =>
    api.get(`/api/projet-dessins/form-meta/${type}/${id}`).then(r => r.data),
  destinataires: (params: { type: DessinOwnerType; id: number; kind: string; travail_id?: number | null; machine_id?: number | null; etape_id?: number | null }): Promise<PlanDestinataire[]> =>
    api.get('/api/projet-dessins/destinataires', {
      params: { ...params, travail_id: params.travail_id || undefined, machine_id: params.machine_id || undefined, etape_id: params.etape_id || undefined },
    }).then(r => r.data),
  /** Any version file by the proxy URL the API returned (operators get their own screen's proxy). */
  getFileBlob: (url: string): Promise<Blob> => api.get(url, { responseType: 'blob' }).then(r => r.data),
};

// ==================== Bureau d'études (Production) ====================
export const bureauEtudesAPI = {
  list: (): Promise<BEBoard> => api.get('/api/production/bureau-etudes').then(r => r.data),
  travauxVus: (id: number): Promise<BECard> => api.put(`/api/production/bureau-etudes/${id}/travaux-vus`).then(r => r.data),
  meta: (): Promise<{ statuts: Record<string, string>; users: { id: number; full_name: string }[] }> =>
    api.get('/api/production/bureau-etudes/meta').then(r => r.data),
  valides: (params: { q?: string; skip?: number; limit?: number }): Promise<{ total: number; items: BECard[] }> =>
    api.get('/api/production/bureau-etudes/valides', { params: { ...params, q: params.q || undefined } }).then(r => r.data),
  candidats: (q?: string): Promise<BECandidat[]> =>
    api.get('/api/production/bureau-etudes/candidats', { params: { q: q || undefined } }).then(r => r.data),
  envoyer: (data: { type: BEType; id: number; instructions?: string | null; forcer?: boolean; motif?: string | null;
                    dessinateur_id?: number | null }): Promise<BECard> =>
    api.post('/api/production/bureau-etudes', data).then(r => r.data),
  commencer: (id: number): Promise<BECard> =>
    api.post(`/api/production/bureau-etudes/${id}/commencer`).then(r => r.data),
  assigner: (id: number, dessinateur_id: number | null): Promise<BECard> =>
    api.put(`/api/production/bureau-etudes/${id}/dessinateur`, { dessinateur_id }).then(r => r.data),
  valider: (id: number, data: { dessine_par?: number | null; date_dessin?: string | null; observations?: string | null; confirme: boolean }): Promise<BECard> =>
    api.put(`/api/production/bureau-etudes/${id}/valider`, data).then(r => r.data),
  sansPlan: (id: number, motif: string): Promise<BECard> =>
    api.put(`/api/production/bureau-etudes/${id}/sans-plan`, { motif }).then(r => r.data),
  renvoyer: (id: number, motif: string): Promise<BECard> =>
    api.put(`/api/production/bureau-etudes/${id}/renvoyer`, { motif }).then(r => r.data),
  historique: (id: number): Promise<{ date: string; description: string; user_name: string | null }[]> =>
    api.get(`/api/production/bureau-etudes/${id}/historique`).then(r => r.data),
  compte: (): Promise<{ attente: number; conception: number }> =>
    api.get('/api/production/bureau-etudes-etat/compte').then(r => r.data),
  etat: (type: BEType, id: number): Promise<BEEtat> =>
    api.get(`/api/production/bureau-etudes-etat/${type}/${id}`).then(r => r.data),
};

// ==================== Notifications API ====================
export const notificationsAPI = {
  list: (params?: {
    page?: number;
    size?: number;
    is_read?: boolean;
  }): Promise<NotificationListResponse> => {
    const sp = new URLSearchParams();
    if (params?.page) sp.append('page', params.page.toString());
    if (params?.size) sp.append('size', params.size.toString());
    if (params?.is_read !== undefined) sp.append('is_read', String(params.is_read));
    const qs = sp.toString();
    return api
      .get(`/api/notifications${qs ? `?${qs}` : ''}`)
      .then((r) => r.data);
  },

  getUnreadCount: (): Promise<NotificationUnreadCountResponse> =>
    api.get('/api/notifications/unread-count').then((r) => r.data),

  markRead: (ids?: number[]): Promise<{ updated: number }> =>
    api
      .post('/api/notifications/mark-read', { ids: ids && ids.length ? ids : null })
      .then((r) => r.data),

  dismiss: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/notifications/${id}`).then((r) => r.data),
};

export const notificationEventsAPI = {
  list: (): Promise<NotificationEventListResponse> =>
    api.get('/api/notification-events').then((r) => r.data),

  getById: (id: number): Promise<NotificationEvent> =>
    api.get(`/api/notification-events/${id}`).then((r) => r.data),

  update: (id: number, role_ids: number[]): Promise<NotificationEvent> =>
    api.put(`/api/notification-events/${id}`, { role_ids }).then((r) => r.data),
};

// Commercial data-visibility (Administration) API
export interface CommercialVisibilityUser {
  id: number;
  full_name: string;
  email: string;
  role: string | null;
  is_manager: boolean;
}

export interface ViewerVisibility {
  viewer_user_id: number;
  viewer_name: string;
  owner_user_ids: number[];
}

export const commercialVisibilityAPI = {
  getUsers: (): Promise<CommercialVisibilityUser[]> =>
    api.get('/api/commercial-visibility/users').then((r) => r.data),

  getAll: (): Promise<ViewerVisibility[]> =>
    api.get('/api/commercial-visibility').then((r) => r.data),

  getForViewer: (viewerId: number): Promise<ViewerVisibility> =>
    api.get(`/api/commercial-visibility/${viewerId}`).then((r) => r.data),

  setForViewer: (viewerId: number, ownerUserIds: number[]): Promise<ViewerVisibility> =>
    api
      .put(`/api/commercial-visibility/${viewerId}`, { owner_user_ids: ownerUserIds })
      .then((r) => r.data),
};

// ---------------------------------------------------------------------------
// Biometric attendance (pointeuse) — raw device punches + device registry
// ---------------------------------------------------------------------------
export interface AttendancePunch {
  id: number;
  device_sn: string;
  device_user_id: string;
  punch_time: string | null;
  status: string | null;
  status_label: string;
  verify_mode: string | null;
  verify_label: string;
  workcode: string | null;
  received_at: string | null;
}

export interface AttendancePunchList {
  items: AttendancePunch[];
  total: number;
}

export interface AttendanceDevice {
  id: number;
  sn: string;
  name: string | null;
  location: string | null;
  first_seen: string | null;
  last_seen: string | null;
  last_ip: string | null;
}

export interface AttendanceDaily {
  device_user_id: string;
  date: string;              // ISO date (YYYY-MM-DD)
  start: string | null;      // HH:MM (first punch)
  end: string | null;        // HH:MM (last punch, if a complete out)
  work_hours: number | null; // END - START
  punch_count: number;
  present: boolean;          // currently clocked in (odd punch count, today)
  punches: string[];         // every punch time of the day (HH:MM, chronological)
  employee_id: number | null;   // linked employee (null for standalone device users)
  employee_name: string | null; // resolved via device_user_id -> employee
  suggested_status: string;     // biometric-derived Pointage status (PRESENT, PRESENT_7H, …)
  draft_status: string | null;  // manual "Statut Pointage" pick (persisted draft), null if none
  worked_minutes: number | null;    // net worked (sessions, lunch excluded); null if incomplete
  lunch_minutes: number | null;     // lunch/break duration (gaps between sessions)
  presence_minutes: number | null;  // départ - arrivée; null if incomplete
  retard: string | null;            // lateness label per règlement ("-1h", "-2h", "-½ j") or null
  flags: string[];                  // e.g. "sortie_manquante", "dejeuner_non_pointe", "en_cours"
}

export interface DeviceUserRow {
  id: number;                // employee id
  matricule: string;
  nom_complet: string;
  device_user_id: string | null;
  device_verify_mode: number; // ADMS Verify mode (18 = face+card, 15 = face…)
  on_device: boolean;
}

export interface DeviceUserList {
  items: DeviceUserRow[];
  total: number;
}

export interface StandaloneUserRow {
  pin: string;
  name: string | null;
  device_sn: string;
  verify_mode: number;
}

export interface AttendanceDailyList {
  items: AttendanceDaily[];
  total: number;
}

export const attendanceAPI = {
  getPunches: (params?: {
    skip?: number;
    limit?: number;
    device_sn?: string;
    device_user_id?: string;
    search?: string;
    start_date?: string;
    end_date?: string;
    since_id?: number;
  }): Promise<AttendancePunchList> => {
    const q = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') q.append(k, String(v));
    });
    return api.get(`/api/attendance/punches?${q}`).then((r) => r.data);
  },

  getDevices: (): Promise<AttendanceDevice[]> =>
    api.get('/api/attendance/devices').then((r) => r.data),
  renameDevice: (deviceId: number, name: string | null): Promise<{ id: number; sn: string; name: string | null }> =>
    api.put(`/api/attendance/devices/${deviceId}`, { name }).then((r) => r.data),

  // Daily attendance summary — one row per (device user, day).
  getDaily: (params?: {
    skip?: number;
    limit?: number;
    search?: string;
    start_date?: string;
    end_date?: string;
    device_sn?: string;
    sort_by?: 'time' | 'name' | 'last' | 'punch';
    sort_dir?: 'asc' | 'desc';
    punch_index?: number;
  }): Promise<AttendanceDailyList> => {
    const q = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') q.append(k, String(v));
    });
    return api.get(`/api/attendance/daily?${q}`).then((r) => r.data);
  },

  // Queue a history re-pull on the device(s). It replays stored punches on its
  // next ~10s heartbeat; idempotent storage drops overlaps.
  backfill: (payload: { sn?: string; start?: string; end?: string }): Promise<{
    queued_for: string[];
    start: string;
    end: string;
  }> => api.post('/api/attendance/backfill', payload).then((r) => r.data),

  // --- Device-user management (link employees to clock PINs) ---
  getDeviceUsers: (params?: { skip?: number; limit?: number; search?: string }): Promise<DeviceUserList> => {
    const q = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') q.append(k, String(v));
    });
    return api.get(`/api/attendance/device-users?${q}`).then((r) => r.data);
  },
  autoAssignPins: (): Promise<{ assigned: number }> =>
    api.post('/api/attendance/device-users/auto-assign').then((r) => r.data),
  setPin: (employeeId: number, deviceUserId: string | null): Promise<DeviceUserRow> =>
    api.put(`/api/attendance/device-users/${employeeId}/pin`, { device_user_id: deviceUserId }).then((r) => r.data),
  setVerifyMode: (employeeId: number, mode: number): Promise<{ id: number; device_verify_mode: number }> =>
    api.put(`/api/attendance/device-users/${employeeId}/verify-mode`, { mode }).then((r) => r.data),
  pushUsers: (employeeId?: number): Promise<{ queued: number; employees: number; devices: number }> =>
    api.post('/api/attendance/device-users/push', { employee_id: employeeId }).then((r) => r.data),
  queryUsers: (): Promise<{ queued_for: string[] }> =>
    api.post('/api/attendance/device-users/query').then((r) => r.data),
  deleteDeviceUser: (pin: string): Promise<{ queued_for: string[] }> =>
    api.delete(`/api/attendance/device-users/${pin}`).then((r) => r.data),

  // Standalone (non-employee) device users — raw PIN+name pushed to the clock.
  getStandaloneUsers: (): Promise<{ items: StandaloneUserRow[] }> =>
    api.get('/api/attendance/device-users/standalone').then((r) => r.data),
  addManualUser: (pin: string, name: string, password?: string, verifyMode?: number): Promise<{ queued: number; devices: number; pin: string; name: string }> =>
    api.post('/api/attendance/device-users/manual', { pin, name, password: password || null, verify_mode: verifyMode ?? null }).then((r) => r.data),
  editManualUser: (oldPin: string, pin: string, name: string, password?: string, verifyMode?: number): Promise<{ queued: number; devices: number; pin: string; name: string; pin_changed: boolean }> =>
    api.put(`/api/attendance/device-users/manual/${oldPin}`, { pin, name, password: password || null, verify_mode: verifyMode ?? null }).then((r) => r.data),
};

// Export both named and default for flexibility
export { api };
// Comptoir API (walk-in clients + offres commerciales).
// Both live under the /api/comptoir slug, so one realtime event refreshes every Comptoir screen.
export const comptoirAPI = {
  // Clients (Comptoir › Clients)
  getClients: (params: { skip?: number; limit?: number; search?: string }): Promise<Paginated<ComptoirClient>> =>
    api.get('/api/comptoir/clients', { params }).then(r => r.data),
  getDeletedClients: (): Promise<ComptoirClient[]> =>
    api.get('/api/comptoir/clients/deleted').then(r => r.data),
  getClientSituation: (id: number): Promise<ComptoirClientSituation> =>
    api.get(`/api/comptoir/clients/${id}/situation`).then(r => r.data),
  createClient: (data: ComptoirClientInput): Promise<ComptoirClient> =>
    api.post('/api/comptoir/clients', data).then(r => r.data),
  updateClient: (id: number, data: Partial<ComptoirClientInput>): Promise<ComptoirClient> =>
    api.put(`/api/comptoir/clients/${id}`, data).then(r => r.data),
  deleteClient: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/comptoir/clients/${id}`).then(r => r.data),
  restoreClient: (id: number): Promise<{ message: string }> =>
    api.post(`/api/comptoir/clients/${id}/restore`).then(r => r.data),

  // Offres commerciales (Comptoir › Offres commerciales)
  getUsersOptions: (): Promise<ComptoirUserOption[]> =>
    api.get('/api/comptoir/offres/users-options').then(r => r.data),
  getDesignations: (): Promise<ComptoirDesignation[]> =>
    api.get('/api/comptoir/offres/designations').then(r => r.data),
  getStats: (): Promise<ComptoirStats> =>
    api.get('/api/comptoir/offres/stats').then(r => r.data),
  getOptions: (): Promise<ComptoirOptions> =>
    api.get('/api/comptoir/offres/options').then(r => r.data),
  getClientOptions: (): Promise<ComptoirClientOption[]> =>
    api.get('/api/comptoir/offres/clients-options').then(r => r.data),
  // Quick creation from the offre wizard (needs only the Offres commerciales permission)
  createClientFromOffre: (data: ComptoirClientInput): Promise<ComptoirClientOption> =>
    api.post('/api/comptoir/offres/clients', data).then(r => r.data),
  getNextReference: (): Promise<{ reference: string }> =>
    api.get('/api/comptoir/offres/next-reference').then(r => r.data),
  getOffres: (params: { skip?: number; limit?: number; search?: string; user_id?: number; client_id?: number }): Promise<Paginated<ComptoirOffre>> =>
    api.get('/api/comptoir/offres', { params }).then(r => r.data),
  getDeletedOffres: (): Promise<ComptoirOffre[]> =>
    api.get('/api/comptoir/offres/deleted').then(r => r.data),
  getOffre: (id: number): Promise<ComptoirOffre> =>
    api.get(`/api/comptoir/offres/${id}`).then(r => r.data),
  createOffre: (data: ComptoirOffreInput): Promise<ComptoirOffre> =>
    api.post('/api/comptoir/offres', data).then(r => r.data),
  updateOffre: (id: number, data: ComptoirOffreInput): Promise<ComptoirOffre> =>
    api.put(`/api/comptoir/offres/${id}`, data).then(r => r.data),
  deleteOffre: (id: number): Promise<{ message: string }> =>
    api.delete(`/api/comptoir/offres/${id}`).then(r => r.data),
  restoreOffre: (id: number): Promise<{ message: string }> =>
    api.post(`/api/comptoir/offres/${id}/restore`).then(r => r.data),
  // Offre with payments / livraisons: requested by anyone, decided by a Manager
  suppressionImpact: (id: number): Promise<ComptoirSuppressionImpact> =>
    api.get(`/api/comptoir/offres/${id}/suppression`).then(r => r.data),
  demanderSuppression: (id: number, motif: string): Promise<ComptoirOffre> =>
    api.post(`/api/comptoir/offres/${id}/suppression/demander`, { motif }).then(r => r.data),
  retirerDemandeSuppression: (id: number): Promise<ComptoirOffre> =>
    api.post(`/api/comptoir/offres/${id}/suppression/annuler`).then(r => r.data),
  refuserSuppression: (id: number, motif: string): Promise<ComptoirOffre> =>
    api.post(`/api/comptoir/offres/${id}/suppression/refuser`, { motif }).then(r => r.data),
  validerSuppression: (id: number, motif: string): Promise<{ message: string; remboursement: string | null; remboursement_montant: number | string; hors_caisse: number | string }> =>
    api.post(`/api/comptoir/offres/${id}/suppression/valider`, { motif }).then(r => r.data),
};

// Comptoir — Services & Projets, payments, deliveries (all under the /api/comptoir slug)
export const comptoirServicesAPI = {
  /** dessinateurs: the DESSINATEUR users offered in « Lancer en production » */
  meta: (): Promise<{ dessinateurs: { id: number; full_name: string }[] }> =>
    api.get('/api/comptoir/services/meta').then(r => r.data),
  list: (params: { skip?: number; limit?: number; search?: string; etat?: string; paiement?: string; en_retard?: boolean; client_id?: number }): Promise<Paginated<ComptoirService>> =>
    api.get('/api/comptoir/services', { params }).then(r => r.data),
  stats: (): Promise<ComptoirServiceStats> =>
    api.get('/api/comptoir/services/stats').then(r => r.data),
  get: (id: number): Promise<ComptoirServiceDetail> =>
    api.get(`/api/comptoir/services/${id}`).then(r => r.data),
  update: (id: number, data: { nature?: string; priorite?: string; deadline?: string | null; description?: string | null }): Promise<ComptoirServiceDetail> =>
    api.put(`/api/comptoir/services/${id}`, data).then(r => r.data),
  livrer: (id: number, data: { date: string; note?: string | null; lignes: { travail_id: number; quantite: number }[] }): Promise<ComptoirLivraison> =>
    api.post(`/api/comptoir/services/${id}/livraisons`, data).then(r => r.data),
  annulerLivraison: (livraisonId: number, motif: string): Promise<ComptoirServiceDetail> =>
    api.post(`/api/comptoir/services/livraisons/${livraisonId}/annuler`, { motif }).then(r => r.data),
  cloturer: (id: number): Promise<ComptoirServiceDetail> =>
    api.post(`/api/comptoir/services/${id}/cloturer`).then(r => r.data),
  rouvrir: (id: number, motif: string): Promise<ComptoirServiceDetail> =>
    api.post(`/api/comptoir/services/${id}/rouvrir`, { motif }).then(r => r.data),
  lancer: (id: number, data: { instructions?: string | null; forcer?: boolean; motif?: string | null;
                               dessinateur_id?: number | null }): Promise<ComptoirServiceDetail> =>
    api.post(`/api/comptoir/services/${id}/lancer`, data).then(r => r.data),
  annulerLancement: (id: number, motif: string): Promise<ComptoirServiceDetail> =>
    api.put(`/api/comptoir/services/${id}/annuler-lancement`, { motif }).then(r => r.data),
  beRenvoyer: (id: number, motif: string): Promise<ComptoirServiceDetail> =>
    api.put(`/api/comptoir/services/${id}/be/renvoyer`, { motif }).then(r => r.data),
  beAttente: (id: number, motif: string): Promise<ComptoirServiceDetail> =>
    api.put(`/api/comptoir/services/${id}/be/attente`, { motif }).then(r => r.data),
  matiereRecue: (id: number, matiereId: number): Promise<ComptoirServiceDetail> =>
    api.post(`/api/comptoir/services/${id}/matieres/${matiereId}/recue`).then(r => r.data),
  historique: (id: number): Promise<ComptoirHistoryLine[]> =>
    api.get(`/api/comptoir/services/${id}/historique`).then(r => r.data),
  production: (id: number): Promise<ComptoirServiceProduction> =>
    api.get(`/api/comptoir/services/${id}/production`).then(r => r.data),
};

export const comptoirCaisseAPI = {
  journal: (params: ComptoirCaisseParams): Promise<ComptoirCaisseJournal> =>
    api.get('/api/comptoir/caisse', { params }).then(r => r.data),
  meta: (): Promise<ComptoirCaisseMeta> =>
    api.get('/api/comptoir/caisse/meta').then(r => r.data),
  get: (id: number): Promise<ComptoirCaisseMove> =>
    api.get(`/api/comptoir/caisse/operations/${id}`).then(r => r.data),
  setOuverture: (data: { montant: number; depuis: string; motif?: string | null }): Promise<ComptoirCaisseOuverture> =>
    api.put('/api/comptoir/caisse/ouverture', data).then(r => r.data),
  createOperation: (data: {
    sens: 'entree' | 'sortie'; categorie: string; montant: number; date: string; motif: string;
    beneficiaire?: string | null; piece_ref?: string | null; service_id?: number | null;
  }): Promise<ComptoirCaisseMove> =>
    api.post('/api/comptoir/caisse/operations', data).then(r => r.data),
  createComptage: (data: { montant: number; motif?: string | null; regulariser: boolean }): Promise<ComptoirCaisseMove> =>
    api.post('/api/comptoir/caisse/comptages', data).then(r => r.data),
  annuler: (id: number, motif: string): Promise<ComptoirCaisseMove> =>
    api.post(`/api/comptoir/caisse/operations/${id}/annuler`, { motif }).then(r => r.data),
  impact: (id: number): Promise<ComptoirCaisseImpact> =>
    api.get(`/api/comptoir/caisse/operations/${id}/impact`).then(r => r.data),
  updateOperation: (id: number, data: {
    categorie: string; montant: number; date: string; motif: string;
    beneficiaire?: string | null; piece_ref?: string | null; service_id?: number | null;
  }): Promise<ComptoirCaisseMove> =>
    api.put(`/api/comptoir/caisse/operations/${id}`, data).then(r => r.data),
  deleteOperation: (id: number): Promise<{ message: string; reference: string }> =>
    api.delete(`/api/comptoir/caisse/operations/${id}`).then(r => r.data),
};

/** Comptoir › Suivi de production: étapes, slots and quantity saisies. */
type SlotParams = Omit<ComptoirEtapeInput, 'designation' | 'note' | 'forcer' | 'qte_demandee'> & { etape_id?: number | null };
/** Comptoir › Tableau de bord (read-only rollup). */
export const comptoirDashboardAPI = {
  get: (): Promise<ComptoirDashboard> => api.get('/api/comptoir/dashboard').then(r => r.data),
  finance: (): Promise<ComptoirFinance> => api.get('/api/comptoir/finance').then(r => r.data),
};

export const comptoirProductionAPI = {
  suivi: (): Promise<ComptoirSuivi> =>
    api.get('/api/comptoir/production').then(r => r.data),
  /** The plans techniques that reach this étape (files through this screen's proxy). */
  travauxVus: (serviceId: number): Promise<ComptoirSuiviService> =>
    api.put(`/api/comptoir/production/services/${serviceId}/travaux-vus`).then(r => r.data),
  etapePlans: (etapeId: number): Promise<ProjetDessin[]> =>
    api.get(`/api/comptoir/production/etapes/${etapeId}/plans`).then(r => r.data),
  service: (serviceId: number): Promise<ComptoirSuiviService> =>
    api.get(`/api/comptoir/production/services/${serviceId}`).then(r => r.data),
  meta: (): Promise<ComptoirSuiviMeta> =>
    api.get('/api/comptoir/production/meta').then(r => r.data),
  planning: (du: string, au: string): Promise<ComptoirPlanning> =>
    api.get('/api/comptoir/production/planning', { params: { du, au } }).then(r => r.data),
  etape: (id: number): Promise<ComptoirEtape> =>
    api.get(`/api/comptoir/production/etapes/${id}`).then(r => r.data),
  conflits: (params: SlotParams): Promise<ComptoirSlotCheck> =>
    api.get('/api/comptoir/production/conflits', { params }).then(r => r.data),
  creneauLibre: (params: SlotParams): Promise<{ date: string | null; heure_debut: string | null }> =>
    api.get('/api/comptoir/production/creneau-libre', { params }).then(r => r.data),
  createEtape: (data: ComptoirEtapeInput): Promise<ComptoirEtape> =>
    api.post('/api/comptoir/production/etapes', data).then(r => r.data),
  updateEtape: (id: number, data: ComptoirEtapeInput): Promise<ComptoirEtape> =>
    api.put(`/api/comptoir/production/etapes/${id}`, data).then(r => r.data),
  moveEtape: (id: number, sens: 'haut' | 'bas') =>
    api.put(`/api/comptoir/production/etapes/${id}/ordre`, { sens }).then(r => r.data),
  deleteEtape: (id: number) =>
    api.delete(`/api/comptoir/production/etapes/${id}`).then(r => r.data),
  saisir: (id: number, data: ComptoirSaisieInput): Promise<ComptoirEtape> =>
    api.post(`/api/comptoir/production/etapes/${id}/saisies`, data).then(r => r.data),
  statut: (id: number, action: ComptoirEtapeAction, motif?: string | null, detail?: string | null): Promise<ComptoirEtape> =>
    api.post(`/api/comptoir/production/etapes/${id}/statut`, { action, motif, detail }).then(r => r.data),
};

/** Matière de l'entreprise on a Comptoir service, linked to the ERP stock (prototype V8 « Stock »). */
export const comptoirMatieresAPI = {
  list: (serviceId: number): Promise<ComptoirMatiereEntreprise[]> =>
    api.get(`/api/comptoir/matieres-entreprise/services/${serviceId}`).then(r => r.data),
  add: (serviceId: number, data: { article_id?: number | null; designation?: string | null; quantite: number; unite?: string | null; observations?: string | null }): Promise<ComptoirMatiereEntreprise[]> =>
    api.post(`/api/comptoir/matieres-entreprise/services/${serviceId}`, data).then(r => r.data),
  update: (id: number, data: { quantite: number; observations?: string | null }): Promise<ComptoirMatiereEntreprise[]> =>
    api.put(`/api/comptoir/matieres-entreprise/${id}`, data).then(r => r.data),
  remove: (id: number): Promise<ComptoirMatiereEntreprise[]> => api.delete(`/api/comptoir/matieres-entreprise/${id}`).then(r => r.data),
  sortie: (id: number): Promise<ComptoirMatiereEntreprise[]> => api.post(`/api/comptoir/matieres-entreprise/${id}/sortie`).then(r => r.data),
  annulerSortie: (id: number, motif: string): Promise<ComptoirMatiereEntreprise[]> =>
    api.post(`/api/comptoir/matieres-entreprise/${id}/annuler-sortie`, { motif }).then(r => r.data),
  achetee: (id: number): Promise<ComptoirMatiereEntreprise[]> => api.post(`/api/comptoir/matieres-entreprise/${id}/achetee`).then(r => r.data),
  stock: (): Promise<ComptoirStockMatiere> => api.get('/api/comptoir/matieres-entreprise/stock').then(r => r.data),
};

export const comptoirDocumentsAPI = {
  list: (): Promise<ComptoirDocuments> => api.get('/api/comptoir/documents').then(r => r.data),
};

export const comptoirPaiementsAPI = {
  dus: (clientId: number): Promise<ComptoirService[]> =>
    api.get('/api/comptoir/paiements/dus', { params: { client_id: clientId } }).then(r => r.data),
  list: (params: { client_id?: number; service_id?: number }): Promise<ComptoirPaiement[]> =>
    api.get('/api/comptoir/paiements', { params }).then(r => r.data),
  get: (id: number): Promise<ComptoirPaiement> =>
    api.get(`/api/comptoir/paiements/${id}`).then(r => r.data),
  create: (data: ComptoirPaiementInput): Promise<ComptoirPaiement> =>
    api.post('/api/comptoir/paiements', data).then(r => r.data),
  impact: (id: number): Promise<ComptoirPaiementImpact> =>
    api.get(`/api/comptoir/paiements/${id}/impact`).then(r => r.data),
  update: (id: number, data: ComptoirPaiementUpdate): Promise<ComptoirPaiement> =>
    api.put(`/api/comptoir/paiements/${id}`, data).then(r => r.data),
  remove: (id: number): Promise<{ message: string; reference: string }> =>
    api.delete(`/api/comptoir/paiements/${id}`).then(r => r.data),
};

export default api;